/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ActiveJobTags,
  AdminAllProfile,
  AdminJobReport,
  AdminProfile,
  AdminReport,
  AdminUser,
  AdminUserList,
  AlumniAlertPreferencesBody,
  AlumniAlertPreferencesResponse,
  AlumniStats,
  AnalyticsResponse,
  AuthUser,
  AvatarResponse,
  BumpCooldownResponse,
  CommentReportItem,
  CommunityEventPost,
  CreateCommunityEventBody,
  CreateFeatureBody,
  CreateFeatureCommentBody,
  CreateJobBody,
  CreateProfileBody,
  CreateProfileResponse,
  DismissSuccessSurveyBody,
  DuplicateProfileError,
  EmailAccountExistsError,
  EnvStatus,
  ErrorResponse,
  ExchangeMobileAuthCodeBody,
  FeatureCommentItem,
  FeatureRequestItem,
  FeatureVoteResponse,
  GetAdminAnalyticsParams,
  GetMyTagSubscriptionsParams,
  HealthStatus,
  JobNotFoundError,
  JobPost,
  JobTag,
  ListAdminCommunityPostsParams,
  ListAdminProfilesParams,
  ListAdminUsersParams,
  ListCommunityEventsParams,
  ListJobsParams,
  ListProfilesParams,
  ListWebhookAuditLogParams,
  ManagedJobPost,
  MobileAuthToken,
  MyInvite,
  OkResponse,
  PatchAdminCommunityPostBody,
  PlatformBroadcastHistoryResponse,
  PlatformUpdatePreviewResponse,
  PostPlatformUnsubscribeBodyOne,
  PostPlatformUnsubscribeBodyTwo,
  PreviewPlatformUpdateBody,
  Profile,
  PublicInvite,
  RecruiterLoginBody,
  RecruiterMagicLinkBody,
  RecruiterPreferencesBody,
  RecruiterRegisterBody,
  RecruiterUser,
  ReportCommunityEventBody,
  ReportJobBody,
  ReportProfileBody,
  ResendManagementLinkBody,
  ResubmitProfileBody,
  SaveProfileResponse,
  SavedCountResponse,
  SavedProfileEntry,
  SendPlatformUpdateBody,
  SendPlatformUpdateResponse,
  SendTestPlatformUpdateBody,
  SendTestPlatformUpdateResponse,
  SetProfileVerifiedBody,
  SurveyResultsResponse,
  TestEmailBody,
  TrackEventBody,
  UpdateCommunityEventBody,
  UpdateFeatureStatusBody,
  UpdateJobBody,
  UpdateProfileBody,
  UpdateSeekingBody,
  UpdateTagSubscriptionsBody,
  UpdateUserRoleBody,
  UpdateVisibilityBody,
  UploadProfileAvatarBody,
  UpvoteCommunityEventResponse,
  VerificationAuditLogEntry,
  WebhookAuditLogPage,
  WebhookStatus,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all verified alumni profiles. Supports search and filter.
 * @summary List verified alumni profiles
 */
export const getListProfilesUrl = (params?: ListProfilesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/profiles?${stringifiedParams}`
    : `/api/profiles`;
};

export const listProfiles = async (
  params?: ListProfilesParams,
  options?: RequestInit,
): Promise<Profile[]> => {
  return customFetch<Profile[]>(getListProfilesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListProfilesQueryKey = (params?: ListProfilesParams) => {
  return [`/api/profiles`, ...(params ? [params] : [])] as const;
};

export const getListProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listProfiles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProfilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProfiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProfilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProfiles>>> = ({
    signal,
  }) => listProfiles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProfiles>>
>;
export type ListProfilesQueryError = ErrorType<unknown>;

/**
 * @summary List verified alumni profiles
 */

export function useListProfiles<
  TData = Awaited<ReturnType<typeof listProfiles>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProfilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProfiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProfilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new alumni profile for the authenticated user. Requires an active session.
 * @summary Create an alumni profile
 */
export const getCreateProfileUrl = () => {
  return `/api/profiles`;
};

export const createProfile = async (
  createProfileBody: CreateProfileBody,
  options?: RequestInit,
): Promise<CreateProfileResponse> => {
  return customFetch<CreateProfileResponse>(getCreateProfileUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProfileBody),
  });
};

export const getCreateProfileMutationOptions = <
  TError = ErrorType<ErrorResponse | DuplicateProfileError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProfile>>,
    TError,
    { data: BodyType<CreateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProfile>>,
  TError,
  { data: BodyType<CreateProfileBody> },
  TContext
> => {
  const mutationKey = ["createProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProfile>>,
    { data: BodyType<CreateProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProfile>>
>;
export type CreateProfileMutationBody = BodyType<CreateProfileBody>;
export type CreateProfileMutationError = ErrorType<
  ErrorResponse | DuplicateProfileError
>;

/**
 * @summary Create an alumni profile
 */
export const useCreateProfile = <
  TError = ErrorType<ErrorResponse | DuplicateProfileError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProfile>>,
    TError,
    { data: BodyType<CreateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProfile>>,
  TError,
  { data: BodyType<CreateProfileBody> },
  TContext
> => {
  return useMutation(getCreateProfileMutationOptions(options));
};

/**
 * Returns all distinct disciplines present in the alumni pool for filter UI
 * @summary List all distinct disciplines
 */
export const getListDisciplinesUrl = () => {
  return `/api/profiles/disciplines`;
};

export const listDisciplines = async (
  options?: RequestInit,
): Promise<string[]> => {
  return customFetch<string[]>(getListDisciplinesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDisciplinesQueryKey = () => {
  return [`/api/profiles/disciplines`] as const;
};

export const getListDisciplinesQueryOptions = <
  TData = Awaited<ReturnType<typeof listDisciplines>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDisciplines>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDisciplinesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDisciplines>>> = ({
    signal,
  }) => listDisciplines({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDisciplines>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDisciplinesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDisciplines>>
>;
export type ListDisciplinesQueryError = ErrorType<unknown>;

/**
 * @summary List all distinct disciplines
 */

export function useListDisciplines<
  TData = Awaited<ReturnType<typeof listDisciplines>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDisciplines>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDisciplinesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns high-level stats about the alumni network
 * @summary Alumni pool statistics
 */
export const getGetAlumniStatsUrl = () => {
  return `/api/profiles/stats`;
};

export const getAlumniStats = async (
  options?: RequestInit,
): Promise<AlumniStats> => {
  return customFetch<AlumniStats>(getGetAlumniStatsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAlumniStatsQueryKey = () => {
  return [`/api/profiles/stats`] as const;
};

export const getGetAlumniStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAlumniStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAlumniStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAlumniStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAlumniStats>>> = ({
    signal,
  }) => getAlumniStats({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAlumniStats>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAlumniStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAlumniStats>>
>;
export type GetAlumniStatsQueryError = ErrorType<unknown>;

/**
 * @summary Alumni pool statistics
 */

export function useGetAlumniStats<
  TData = Awaited<ReturnType<typeof getAlumniStats>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAlumniStats>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAlumniStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sets or clears the actively_seeking_updated_at timestamp. Only the profile owner can call this.
 * @summary Toggle actively seeking status
 */
export const getUpdateSeekingStatusUrl = (id: number) => {
  return `/api/profiles/${id}/seeking`;
};

export const updateSeekingStatus = async (
  id: number,
  updateSeekingBody: UpdateSeekingBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getUpdateSeekingStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSeekingBody),
  });
};

export const getUpdateSeekingStatusMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSeekingStatus>>,
    TError,
    { id: number; data: BodyType<UpdateSeekingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSeekingStatus>>,
  TError,
  { id: number; data: BodyType<UpdateSeekingBody> },
  TContext
> => {
  const mutationKey = ["updateSeekingStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSeekingStatus>>,
    { id: number; data: BodyType<UpdateSeekingBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSeekingStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSeekingStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSeekingStatus>>
>;
export type UpdateSeekingStatusMutationBody = BodyType<UpdateSeekingBody>;
export type UpdateSeekingStatusMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Toggle actively seeking status
 */
export const useUpdateSeekingStatus = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSeekingStatus>>,
    TError,
    { id: number; data: BodyType<UpdateSeekingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSeekingStatus>>,
  TError,
  { id: number; data: BodyType<UpdateSeekingBody> },
  TContext
> => {
  return useMutation(getUpdateSeekingStatusMutationOptions(options));
};

/**
 * Returns a profile by ID. Verified profiles are public. An owner can view their own unverified profile.
 * @summary Get a single alumni profile
 */
export const getGetProfileUrl = (id: number) => {
  return `/api/profiles/${id}`;
};

export const getProfile = async (
  id: number,
  options?: RequestInit,
): Promise<Profile> => {
  return customFetch<Profile>(getGetProfileUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProfileQueryKey = (id: number) => {
  return [`/api/profiles/${id}`] as const;
};

export const getGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfile>>> = ({
    signal,
  }) => getProfile(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfile>>
>;
export type GetProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a single alumni profile
 */

export function useGetProfile<
  TData = Awaited<ReturnType<typeof getProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProfileQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Permanently removes the authenticated user's own profile. Only the profile owner can call this.
 * @summary Delete an alumni profile
 */
export const getDeleteProfileUrl = (id: number) => {
  return `/api/profiles/${id}`;
};

export const deleteProfile = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteProfileUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProfile>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProfile>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteProfile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProfile>>
>;

export type DeleteProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete an alumni profile
 */
export const useDeleteProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProfile>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteProfileMutationOptions(options));
};

/**
 * Updates the authenticated user's own profile. Only the profile owner can call this.
 * @summary Update an alumni profile
 */
export const getUpdateProfileUrl = (id: number) => {
  return `/api/profiles/${id}`;
};

export const updateProfile = async (
  id: number,
  updateProfileBody: UpdateProfileBody,
  options?: RequestInit,
): Promise<Profile> => {
  return customFetch<Profile>(getUpdateProfileUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileBody),
  });
};

export const getUpdateProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { id: number; data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { id: number; data: BodyType<UpdateProfileBody> },
  TContext
> => {
  const mutationKey = ["updateProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfile>>,
    { id: number; data: BodyType<UpdateProfileBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProfile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfile>>
>;
export type UpdateProfileMutationBody = BodyType<UpdateProfileBody>;
export type UpdateProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update an alumni profile
 */
export const useUpdateProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { id: number; data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { id: number; data: BodyType<UpdateProfileBody> },
  TContext
> => {
  return useMutation(getUpdateProfileMutationOptions(options));
};

/**
 * Accepts a jpeg/png/webp image up to 5 MB, re-encodes it to a 256x256 WebP, and sets it as the profile's custom avatar. Only the profile owner can call this.
 * @summary Upload a custom profile avatar
 */
export const getUploadProfileAvatarUrl = (id: number) => {
  return `/api/profiles/${id}/avatar`;
};

export const uploadProfileAvatar = async (
  id: number,
  uploadProfileAvatarBody: UploadProfileAvatarBody,
  options?: RequestInit,
): Promise<AvatarResponse> => {
  const formData = new FormData();
  formData.append(`file`, uploadProfileAvatarBody.file);

  return customFetch<AvatarResponse>(getUploadProfileAvatarUrl(id), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadProfileAvatarMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadProfileAvatar>>,
    TError,
    { id: number; data: BodyType<UploadProfileAvatarBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadProfileAvatar>>,
  TError,
  { id: number; data: BodyType<UploadProfileAvatarBody> },
  TContext
> => {
  const mutationKey = ["uploadProfileAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadProfileAvatar>>,
    { id: number; data: BodyType<UploadProfileAvatarBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return uploadProfileAvatar(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadProfileAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadProfileAvatar>>
>;
export type UploadProfileAvatarMutationBody = BodyType<UploadProfileAvatarBody>;
export type UploadProfileAvatarMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upload a custom profile avatar
 */
export const useUploadProfileAvatar = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadProfileAvatar>>,
    TError,
    { id: number; data: BodyType<UploadProfileAvatarBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadProfileAvatar>>,
  TError,
  { id: number; data: BodyType<UploadProfileAvatarBody> },
  TContext
> => {
  return useMutation(getUploadProfileAvatarMutationOptions(options));
};

/**
 * Deletes the custom avatar and reverts to the retained OAuth avatar, or to no avatar if none exists. Only the profile owner can call this.
 * @summary Remove the custom profile avatar
 */
export const getRemoveProfileAvatarUrl = (id: number) => {
  return `/api/profiles/${id}/avatar`;
};

export const removeProfileAvatar = async (
  id: number,
  options?: RequestInit,
): Promise<AvatarResponse> => {
  return customFetch<AvatarResponse>(getRemoveProfileAvatarUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveProfileAvatarMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeProfileAvatar>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeProfileAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["removeProfileAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeProfileAvatar>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return removeProfileAvatar(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveProfileAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeProfileAvatar>>
>;

export type RemoveProfileAvatarMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Remove the custom profile avatar
 */
export const useRemoveProfileAvatar = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeProfileAvatar>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeProfileAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRemoveProfileAvatarMutationOptions(options));
};

/**
 * Hides or shows the profile in the public directory. Only the profile owner can call this.
 * @summary Toggle profile visibility in the directory
 */
export const getUpdateVisibilityUrl = (id: number) => {
  return `/api/profiles/${id}/visibility`;
};

export const updateVisibility = async (
  id: number,
  updateVisibilityBody: UpdateVisibilityBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getUpdateVisibilityUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateVisibilityBody),
  });
};

export const getUpdateVisibilityMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVisibility>>,
    TError,
    { id: number; data: BodyType<UpdateVisibilityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVisibility>>,
  TError,
  { id: number; data: BodyType<UpdateVisibilityBody> },
  TContext
> => {
  const mutationKey = ["updateVisibility"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVisibility>>,
    { id: number; data: BodyType<UpdateVisibilityBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVisibility(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVisibility>>
>;
export type UpdateVisibilityMutationBody = BodyType<UpdateVisibilityBody>;
export type UpdateVisibilityMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Toggle profile visibility in the directory
 */
export const useUpdateVisibility = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVisibility>>,
    TError,
    { id: number; data: BodyType<UpdateVisibilityBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVisibility>>,
  TError,
  { id: number; data: BodyType<UpdateVisibilityBody> },
  TContext
> => {
  return useMutation(getUpdateVisibilityMutationOptions(options));
};

/**
 * Records the alumni's survey response and marks the survey as answered so it no longer appears. Auth-gated to verified alumni.
 * @summary Submit the Open-to-Work success survey and dismiss it
 */
export const getDismissSuccessSurveyUrl = () => {
  return `/api/profiles/me/dismiss-success-survey`;
};

export const dismissSuccessSurvey = async (
  dismissSuccessSurveyBody: DismissSuccessSurveyBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissSuccessSurveyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(dismissSuccessSurveyBody),
  });
};

export const getDismissSuccessSurveyMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissSuccessSurvey>>,
    TError,
    { data: BodyType<DismissSuccessSurveyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissSuccessSurvey>>,
  TError,
  { data: BodyType<DismissSuccessSurveyBody> },
  TContext
> => {
  const mutationKey = ["dismissSuccessSurvey"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissSuccessSurvey>>,
    { data: BodyType<DismissSuccessSurveyBody> }
  > = (props) => {
    const { data } = props ?? {};

    return dismissSuccessSurvey(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissSuccessSurveyMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissSuccessSurvey>>
>;
export type DismissSuccessSurveyMutationBody =
  BodyType<DismissSuccessSurveyBody>;
export type DismissSuccessSurveyMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Submit the Open-to-Work success survey and dismiss it
 */
export const useDismissSuccessSurvey = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissSuccessSurvey>>,
    TError,
    { data: BodyType<DismissSuccessSurveyBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissSuccessSurvey>>,
  TError,
  { data: BodyType<DismissSuccessSurveyBody> },
  TContext
> => {
  return useMutation(getDismissSuccessSurveyMutationOptions(options));
};

/**
 * Marks the welcome banner as dismissed for the authenticated alumni at the account level. Once called, the banner will never appear again for this account on any device.
 * @summary Permanently dismiss the welcome speech bubble
 */
export const getDismissWelcomeBannerUrl = () => {
  return `/api/profiles/me/dismiss-welcome-banner`;
};

export const dismissWelcomeBanner = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissWelcomeBannerUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDismissWelcomeBannerMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissWelcomeBanner>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissWelcomeBanner>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["dismissWelcomeBanner"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissWelcomeBanner>>,
    void
  > = () => {
    return dismissWelcomeBanner(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissWelcomeBannerMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissWelcomeBanner>>
>;

export type DismissWelcomeBannerMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Permanently dismiss the welcome speech bubble
 */
export const useDismissWelcomeBanner = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissWelcomeBanner>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissWelcomeBanner>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDismissWelcomeBannerMutationOptions(options));
};

/**
 * Marks the bookmark hint as dismissed for the authenticated alumni at the account level. Once called, the hint will never appear again for this account on any device.
 * @summary Permanently dismiss the bookmark hint speech bubble
 */
export const getDismissBookmarkHintUrl = () => {
  return `/api/profiles/me/dismiss-bookmark-hint`;
};

export const dismissBookmarkHint = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissBookmarkHintUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDismissBookmarkHintMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissBookmarkHint>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissBookmarkHint>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["dismissBookmarkHint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissBookmarkHint>>,
    void
  > = () => {
    return dismissBookmarkHint(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissBookmarkHintMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissBookmarkHint>>
>;

export type DismissBookmarkHintMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Permanently dismiss the bookmark hint speech bubble
 */
export const useDismissBookmarkHint = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissBookmarkHint>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissBookmarkHint>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDismissBookmarkHintMutationOptions(options));
};

/**
 * Marks the one-time onboarding modal as dismissed for the authenticated alumni at the account level. Once called, the modal will never appear again for this account on any device.
 * @summary Permanently dismiss the post-verification onboarding modal
 */
export const getDismissOnboardingModalUrl = () => {
  return `/api/profiles/me/dismiss-onboarding-modal`;
};

export const dismissOnboardingModal = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissOnboardingModalUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDismissOnboardingModalMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissOnboardingModal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissOnboardingModal>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["dismissOnboardingModal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissOnboardingModal>>,
    void
  > = () => {
    return dismissOnboardingModal(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissOnboardingModalMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissOnboardingModal>>
>;

export type DismissOnboardingModalMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Permanently dismiss the post-verification onboarding modal
 */
export const useDismissOnboardingModal = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissOnboardingModal>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissOnboardingModal>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDismissOnboardingModalMutationOptions(options));
};

/**
 * Returns the current member's personal invite code and shareable invite URL, lazily generating the code on first request. Auth-gated.
 * @summary Get the authenticated member's personal invite link
 */
export const getGetMyInviteUrl = () => {
  return `/api/invites/me`;
};

export const getMyInvite = async (options?: RequestInit): Promise<MyInvite> => {
  return customFetch<MyInvite>(getGetMyInviteUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyInviteQueryKey = () => {
  return [`/api/invites/me`] as const;
};

export const getGetMyInviteQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyInvite>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyInvite>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyInviteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyInvite>>> = ({
    signal,
  }) => getMyInvite({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyInvite>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyInviteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyInvite>>
>;
export type GetMyInviteQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the authenticated member's personal invite link
 */

export function useGetMyInvite<
  TData = Awaited<ReturnType<typeof getMyInvite>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyInvite>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyInviteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Public endpoint used by the /join landing to display who invited the visitor. Returns the inviter's display name, or 404 when the code is unknown.
 * @summary Resolve a public invite code to its inviter
 */
export const getGetInviteByCodeUrl = (code: string) => {
  return `/api/invites/${code}`;
};

export const getInviteByCode = async (
  code: string,
  options?: RequestInit,
): Promise<PublicInvite> => {
  return customFetch<PublicInvite>(getGetInviteByCodeUrl(code), {
    ...options,
    method: "GET",
  });
};

export const getGetInviteByCodeQueryKey = (code: string) => {
  return [`/api/invites/${code}`] as const;
};

export const getGetInviteByCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getInviteByCode>>,
  TError = ErrorType<ErrorResponse>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInviteByCode>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInviteByCodeQueryKey(code);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInviteByCode>>> = ({
    signal,
  }) => getInviteByCode(code, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInviteByCode>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInviteByCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInviteByCode>>
>;
export type GetInviteByCodeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Resolve a public invite code to its inviter
 */

export function useGetInviteByCode<
  TData = Awaited<ReturnType<typeof getInviteByCode>>,
  TError = ErrorType<ErrorResponse>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInviteByCode>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInviteByCodeQueryOptions(code, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Submits a report on an alumni profile. Increments reportCount and creates a profileReports record.
 * @summary Report a profile
 */
export const getReportProfileUrl = (id: number) => {
  return `/api/profiles/${id}/report`;
};

export const reportProfile = async (
  id: number,
  reportProfileBody?: ReportProfileBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getReportProfileUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reportProfileBody),
  });
};

export const getReportProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportProfile>>,
    TError,
    { id: number; data: BodyType<ReportProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportProfile>>,
  TError,
  { id: number; data: BodyType<ReportProfileBody> },
  TContext
> => {
  const mutationKey = ["reportProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportProfile>>,
    { id: number; data: BodyType<ReportProfileBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reportProfile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportProfile>>
>;
export type ReportProfileMutationBody = BodyType<ReportProfileBody>;
export type ReportProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Report a profile
 */
export const useReportProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportProfile>>,
    TError,
    { id: number; data: BodyType<ReportProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportProfile>>,
  TError,
  { id: number; data: BodyType<ReportProfileBody> },
  TContext
> => {
  return useMutation(getReportProfileMutationOptions(options));
};

/**
 * Submits a report on a job post. Increments reportCount and creates a jobPostReports record. Requires authentication.
 * @summary Report a job post
 */
export const getReportJobUrl = (id: number) => {
  return `/api/jobs/${id}/report`;
};

export const reportJob = async (
  id: number,
  reportJobBody?: ReportJobBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getReportJobUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reportJobBody),
  });
};

export const getReportJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportJob>>,
    TError,
    { id: number; data: BodyType<ReportJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportJob>>,
  TError,
  { id: number; data: BodyType<ReportJobBody> },
  TContext
> => {
  const mutationKey = ["reportJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportJob>>,
    { id: number; data: BodyType<ReportJobBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reportJob(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportJob>>
>;
export type ReportJobMutationBody = BodyType<ReportJobBody>;
export type ReportJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Report a job post
 */
export const useReportJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportJob>>,
    TError,
    { id: number; data: BodyType<ReportJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportJob>>,
  TError,
  { id: number; data: BodyType<ReportJobBody> },
  TContext
> => {
  return useMutation(getReportJobMutationOptions(options));
};

/**
 * Unlinks the Discord account from the current user's session and database record. Requires an active session. Returns 400 if Discord is the only linked provider (account would become inaccessible).
 * @summary Disconnect Discord account
 */
export const getDisconnectDiscordUrl = () => {
  return `/api/auth/discord/disconnect`;
};

export const disconnectDiscord = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDisconnectDiscordUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectDiscordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectDiscord>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectDiscord>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectDiscord"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectDiscord>>,
    void
  > = () => {
    return disconnectDiscord(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectDiscordMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectDiscord>>
>;

export type DisconnectDiscordMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Disconnect Discord account
 */
export const useDisconnectDiscord = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectDiscord>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectDiscord>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectDiscordMutationOptions(options));
};

/**
 * Unlinks the LinkedIn account from the current user. Requires an active session. Returns 400 if LinkedIn is the only linked provider.
 * @summary Disconnect LinkedIn account
 */
export const getDisconnectLinkedinUrl = () => {
  return `/api/auth/linkedin/disconnect`;
};

export const disconnectLinkedin = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDisconnectLinkedinUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectLinkedinMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectLinkedin>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectLinkedin>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectLinkedin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectLinkedin>>,
    void
  > = () => {
    return disconnectLinkedin(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectLinkedinMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectLinkedin>>
>;

export type DisconnectLinkedinMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Disconnect LinkedIn account
 */
export const useDisconnectLinkedin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectLinkedin>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectLinkedin>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectLinkedinMutationOptions(options));
};

/**
 * Unlinks the Google account from the current user. Requires an active session. Returns 400 if Google is the only linked provider.
 * @summary Disconnect Google account
 */
export const getDisconnectGoogleUrl = () => {
  return `/api/auth/google/disconnect`;
};

export const disconnectGoogle = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDisconnectGoogleUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDisconnectGoogleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGoogle>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectGoogle>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectGoogle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectGoogle>>,
    void
  > = () => {
    return disconnectGoogle(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectGoogleMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectGoogle>>
>;

export type DisconnectGoogleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Disconnect Google account
 */
export const useDisconnectGoogle = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGoogle>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectGoogle>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDisconnectGoogleMutationOptions(options));
};

/**
 * Redeems a short-lived (60 s), single-use auth code that was delivered via the `thecarrynetwork://auth?code=` deep link after LinkedIn OAuth. Returns the bearer token and basic user info. The code is invalidated on first use and cannot be replayed.

 * @summary Exchange a one-time mobile auth code for a bearer token
 */
export const getExchangeMobileAuthCodeUrl = () => {
  return `/api/auth/mobile/exchange`;
};

export const exchangeMobileAuthCode = async (
  exchangeMobileAuthCodeBody: ExchangeMobileAuthCodeBody,
  options?: RequestInit,
): Promise<MobileAuthToken> => {
  return customFetch<MobileAuthToken>(getExchangeMobileAuthCodeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(exchangeMobileAuthCodeBody),
  });
};

export const getExchangeMobileAuthCodeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exchangeMobileAuthCode>>,
    TError,
    { data: BodyType<ExchangeMobileAuthCodeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof exchangeMobileAuthCode>>,
  TError,
  { data: BodyType<ExchangeMobileAuthCodeBody> },
  TContext
> => {
  const mutationKey = ["exchangeMobileAuthCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof exchangeMobileAuthCode>>,
    { data: BodyType<ExchangeMobileAuthCodeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return exchangeMobileAuthCode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExchangeMobileAuthCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof exchangeMobileAuthCode>>
>;
export type ExchangeMobileAuthCodeMutationBody =
  BodyType<ExchangeMobileAuthCodeBody>;
export type ExchangeMobileAuthCodeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Exchange a one-time mobile auth code for a bearer token
 */
export const useExchangeMobileAuthCode = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof exchangeMobileAuthCode>>,
    TError,
    { data: BodyType<ExchangeMobileAuthCodeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof exchangeMobileAuthCode>>,
  TError,
  { data: BodyType<ExchangeMobileAuthCodeBody> },
  TContext
> => {
  return useMutation(getExchangeMobileAuthCodeMutationOptions(options));
};

/**
 * Returns the currently authenticated user from session, or 401 if not logged in.
 * @summary Get current authenticated user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<AuthUser> => {
  return customFetch<AuthUser>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current authenticated user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Server-side fetch of the requesting user's profile picture from the named provider (avoids CORS and expiring CDN URLs). Only URLs already stored for the logged-in user are fetched. Returns the image re-encoded as a 256x256 WebP.
 * @summary Fetch the authenticated user's avatar image from a connected OAuth provider
 */
export const getGetProviderAvatarUrl = (
  provider: "linkedin" | "google" | "discord",
) => {
  return `/api/auth/avatar/${provider}`;
};

export const getProviderAvatar = async (
  provider: "linkedin" | "google" | "discord",
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getGetProviderAvatarUrl(provider), {
    ...options,
    method: "GET",
  });
};

export const getGetProviderAvatarQueryKey = (
  provider: "linkedin" | "google" | "discord",
) => {
  return [`/api/auth/avatar/${provider}`] as const;
};

export const getGetProviderAvatarQueryOptions = <
  TData = Awaited<ReturnType<typeof getProviderAvatar>>,
  TError = ErrorType<ErrorResponse>,
>(
  provider: "linkedin" | "google" | "discord",
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProviderAvatar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProviderAvatarQueryKey(provider);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProviderAvatar>>
  > = ({ signal }) =>
    getProviderAvatar(provider, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!provider,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProviderAvatar>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProviderAvatarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProviderAvatar>>
>;
export type GetProviderAvatarQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Fetch the authenticated user's avatar image from a connected OAuth provider
 */

export function useGetProviderAvatar<
  TData = Awaited<ReturnType<typeof getProviderAvatar>>,
  TError = ErrorType<ErrorResponse>,
>(
  provider: "linkedin" | "google" | "discord",
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProviderAvatar>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProviderAvatarQueryOptions(provider, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Issues a fresh magic link for the given business email and fires the Make.com webhook to deliver it. Idempotent — safe to call again when a previous link has expired.
 * @summary Request a recruiter magic-link login email
 */
export const getRequestRecruiterMagicLinkUrl = () => {
  return `/api/auth/recruiter/magic-link`;
};

export const requestRecruiterMagicLink = async (
  recruiterMagicLinkBody: RecruiterMagicLinkBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getRequestRecruiterMagicLinkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recruiterMagicLinkBody),
  });
};

export const getRequestRecruiterMagicLinkMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestRecruiterMagicLink>>,
    TError,
    { data: BodyType<RecruiterMagicLinkBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestRecruiterMagicLink>>,
  TError,
  { data: BodyType<RecruiterMagicLinkBody> },
  TContext
> => {
  const mutationKey = ["requestRecruiterMagicLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestRecruiterMagicLink>>,
    { data: BodyType<RecruiterMagicLinkBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestRecruiterMagicLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestRecruiterMagicLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestRecruiterMagicLink>>
>;
export type RequestRecruiterMagicLinkMutationBody =
  BodyType<RecruiterMagicLinkBody>;
export type RequestRecruiterMagicLinkMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Request a recruiter magic-link login email
 */
export const useRequestRecruiterMagicLink = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestRecruiterMagicLink>>,
    TError,
    { data: BodyType<RecruiterMagicLinkBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestRecruiterMagicLink>>,
  TError,
  { data: BodyType<RecruiterMagicLinkBody> },
  TContext
> => {
  return useMutation(getRequestRecruiterMagicLinkMutationOptions(options));
};

/**
 * Creates a recruiter account with business email validation.
 * @summary Register a new recruiter account
 */
export const getRegisterRecruiterUrl = () => {
  return `/api/recruiters/register`;
};

export const registerRecruiter = async (
  recruiterRegisterBody: RecruiterRegisterBody,
  options?: RequestInit,
): Promise<RecruiterUser> => {
  return customFetch<RecruiterUser>(getRegisterRecruiterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recruiterRegisterBody),
  });
};

export const getRegisterRecruiterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerRecruiter>>,
    TError,
    { data: BodyType<RecruiterRegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerRecruiter>>,
  TError,
  { data: BodyType<RecruiterRegisterBody> },
  TContext
> => {
  const mutationKey = ["registerRecruiter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerRecruiter>>,
    { data: BodyType<RecruiterRegisterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return registerRecruiter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterRecruiterMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerRecruiter>>
>;
export type RegisterRecruiterMutationBody = BodyType<RecruiterRegisterBody>;
export type RegisterRecruiterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new recruiter account
 */
export const useRegisterRecruiter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerRecruiter>>,
    TError,
    { data: BodyType<RecruiterRegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerRecruiter>>,
  TError,
  { data: BodyType<RecruiterRegisterBody> },
  TContext
> => {
  return useMutation(getRegisterRecruiterMutationOptions(options));
};

/**
 * Authenticates a recruiter and sets a session cookie.
 * @summary Log in as a recruiter
 */
export const getLoginRecruiterUrl = () => {
  return `/api/recruiters/login`;
};

export const loginRecruiter = async (
  recruiterLoginBody: RecruiterLoginBody,
  options?: RequestInit,
): Promise<RecruiterUser> => {
  return customFetch<RecruiterUser>(getLoginRecruiterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recruiterLoginBody),
  });
};

export const getLoginRecruiterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginRecruiter>>,
    TError,
    { data: BodyType<RecruiterLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginRecruiter>>,
  TError,
  { data: BodyType<RecruiterLoginBody> },
  TContext
> => {
  const mutationKey = ["loginRecruiter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginRecruiter>>,
    { data: BodyType<RecruiterLoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return loginRecruiter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginRecruiterMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginRecruiter>>
>;
export type LoginRecruiterMutationBody = BodyType<RecruiterLoginBody>;
export type LoginRecruiterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Log in as a recruiter
 */
export const useLoginRecruiter = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginRecruiter>>,
    TError,
    { data: BodyType<RecruiterLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginRecruiter>>,
  TError,
  { data: BodyType<RecruiterLoginBody> },
  TContext
> => {
  return useMutation(getLoginRecruiterMutationOptions(options));
};

/**
 * Returns the currently authenticated recruiter, or 401 if not logged in.
 * @summary Get current recruiter session
 */
export const getGetRecruiterMeUrl = () => {
  return `/api/recruiters/me`;
};

export const getRecruiterMe = async (
  options?: RequestInit,
): Promise<RecruiterUser> => {
  return customFetch<RecruiterUser>(getGetRecruiterMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRecruiterMeQueryKey = () => {
  return [`/api/recruiters/me`] as const;
};

export const getGetRecruiterMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecruiterMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecruiterMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecruiterMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecruiterMe>>> = ({
    signal,
  }) => getRecruiterMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecruiterMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecruiterMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecruiterMe>>
>;
export type GetRecruiterMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current recruiter session
 */

export function useGetRecruiterMe<
  TData = Awaited<ReturnType<typeof getRecruiterMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecruiterMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecruiterMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Log out recruiter
 */
export const getLogoutRecruiterUrl = () => {
  return `/api/recruiters/logout`;
};

export const logoutRecruiter = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getLogoutRecruiterUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutRecruiterMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutRecruiter>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutRecruiter>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logoutRecruiter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutRecruiter>>,
    void
  > = () => {
    return logoutRecruiter(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutRecruiterMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutRecruiter>>
>;

export type LogoutRecruiterMutationError = ErrorType<unknown>;

/**
 * @summary Log out recruiter
 */
export const useLogoutRecruiter = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutRecruiter>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logoutRecruiter>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutRecruiterMutationOptions(options));
};

/**
 * Returns all profiles saved by the currently authenticated recruiter.
 * @summary List saved profiles for the authenticated recruiter
 */
export const getListSavedProfilesUrl = () => {
  return `/api/recruiters/saved`;
};

export const listSavedProfiles = async (
  options?: RequestInit,
): Promise<SavedProfileEntry[]> => {
  return customFetch<SavedProfileEntry[]>(getListSavedProfilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSavedProfilesQueryKey = () => {
  return [`/api/recruiters/saved`] as const;
};

export const getListSavedProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSavedProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedProfiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSavedProfilesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSavedProfiles>>
  > = ({ signal }) => listSavedProfiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSavedProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSavedProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSavedProfiles>>
>;
export type ListSavedProfilesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List saved profiles for the authenticated recruiter
 */

export function useListSavedProfiles<
  TData = Awaited<ReturnType<typeof listSavedProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSavedProfiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSavedProfilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Marks the bookmark hint as dismissed for the authenticated recruiter at the account level. Once called, the hint will never appear again for this account on any device.
 * @summary Permanently dismiss the bookmark hint speech bubble for a recruiter
 */
export const getDismissRecruiterBookmarkHintUrl = () => {
  return `/api/recruiters/me/dismiss-bookmark-hint`;
};

export const dismissRecruiterBookmarkHint = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDismissRecruiterBookmarkHintUrl(), {
    ...options,
    method: "POST",
  });
};

export const getDismissRecruiterBookmarkHintMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissRecruiterBookmarkHint>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissRecruiterBookmarkHint>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["dismissRecruiterBookmarkHint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissRecruiterBookmarkHint>>,
    void
  > = () => {
    return dismissRecruiterBookmarkHint(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissRecruiterBookmarkHintMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissRecruiterBookmarkHint>>
>;

export type DismissRecruiterBookmarkHintMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Permanently dismiss the bookmark hint speech bubble for a recruiter
 */
export const useDismissRecruiterBookmarkHint = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissRecruiterBookmarkHint>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissRecruiterBookmarkHint>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDismissRecruiterBookmarkHintMutationOptions(options));
};

/**
 * Updates alert preferences for the currently authenticated recruiter.
 * @summary Update recruiter alert preferences
 */
export const getPatchRecruiterMePreferencesUrl = () => {
  return `/api/recruiters/me/preferences`;
};

export const patchRecruiterMePreferences = async (
  recruiterPreferencesBody: RecruiterPreferencesBody,
  options?: RequestInit,
): Promise<RecruiterUser> => {
  return customFetch<RecruiterUser>(getPatchRecruiterMePreferencesUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recruiterPreferencesBody),
  });
};

export const getPatchRecruiterMePreferencesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRecruiterMePreferences>>,
    TError,
    { data: BodyType<RecruiterPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRecruiterMePreferences>>,
  TError,
  { data: BodyType<RecruiterPreferencesBody> },
  TContext
> => {
  const mutationKey = ["patchRecruiterMePreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRecruiterMePreferences>>,
    { data: BodyType<RecruiterPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return patchRecruiterMePreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchRecruiterMePreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRecruiterMePreferences>>
>;
export type PatchRecruiterMePreferencesMutationBody =
  BodyType<RecruiterPreferencesBody>;
export type PatchRecruiterMePreferencesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update recruiter alert preferences
 */
export const usePatchRecruiterMePreferences = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRecruiterMePreferences>>,
    TError,
    { data: BodyType<RecruiterPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchRecruiterMePreferences>>,
  TError,
  { data: BodyType<RecruiterPreferencesBody> },
  TContext
> => {
  return useMutation(getPatchRecruiterMePreferencesMutationOptions(options));
};

/**
 * Saves an alumni profile to the recruiter's shortlist. Idempotent. Returns savedCountBefore so the client can detect the first-ever save.
 * @summary Save a profile
 */
export const getSaveProfileUrl = (profileId: number) => {
  return `/api/recruiters/saved/${profileId}`;
};

export const saveProfile = async (
  profileId: number,
  options?: RequestInit,
): Promise<SaveProfileResponse> => {
  return customFetch<SaveProfileResponse>(getSaveProfileUrl(profileId), {
    ...options,
    method: "POST",
  });
};

export const getSaveProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  const mutationKey = ["saveProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveProfile>>,
    { profileId: number }
  > = (props) => {
    const { profileId } = props ?? {};

    return saveProfile(profileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveProfile>>
>;

export type SaveProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Save a profile
 */
export const useSaveProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  return useMutation(getSaveProfileMutationOptions(options));
};

/**
 * Removes an alumni profile from the recruiter's shortlist.
 * @summary Unsave a profile
 */
export const getUnsaveProfileUrl = (profileId: number) => {
  return `/api/recruiters/saved/${profileId}`;
};

export const unsaveProfile = async (
  profileId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getUnsaveProfileUrl(profileId), {
    ...options,
    method: "DELETE",
  });
};

export const getUnsaveProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsaveProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unsaveProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  const mutationKey = ["unsaveProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsaveProfile>>,
    { profileId: number }
  > = (props) => {
    const { profileId } = props ?? {};

    return unsaveProfile(profileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnsaveProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof unsaveProfile>>
>;

export type UnsaveProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Unsave a profile
 */
export const useUnsaveProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsaveProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unsaveProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  return useMutation(getUnsaveProfileMutationOptions(options));
};

/**
 * Returns all profiles saved by the currently authenticated verified alumni.
 * @summary List saved profiles for the authenticated verified alumni
 */
export const getListAlumniSavedProfilesUrl = () => {
  return `/api/profiles/saved`;
};

export const listAlumniSavedProfiles = async (
  options?: RequestInit,
): Promise<SavedProfileEntry[]> => {
  return customFetch<SavedProfileEntry[]>(getListAlumniSavedProfilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAlumniSavedProfilesQueryKey = () => {
  return [`/api/profiles/saved`] as const;
};

export const getListAlumniSavedProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAlumniSavedProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAlumniSavedProfiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAlumniSavedProfilesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAlumniSavedProfiles>>
  > = ({ signal }) => listAlumniSavedProfiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAlumniSavedProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAlumniSavedProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAlumniSavedProfiles>>
>;
export type ListAlumniSavedProfilesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List saved profiles for the authenticated verified alumni
 */

export function useListAlumniSavedProfiles<
  TData = Awaited<ReturnType<typeof listAlumniSavedProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAlumniSavedProfiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAlumniSavedProfilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Count saved profiles for the authenticated verified alumni
 */
export const getGetAlumniSavedCountUrl = () => {
  return `/api/profiles/saved/count`;
};

export const getAlumniSavedCount = async (
  options?: RequestInit,
): Promise<SavedCountResponse> => {
  return customFetch<SavedCountResponse>(getGetAlumniSavedCountUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAlumniSavedCountQueryKey = () => {
  return [`/api/profiles/saved/count`] as const;
};

export const getGetAlumniSavedCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getAlumniSavedCount>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAlumniSavedCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAlumniSavedCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAlumniSavedCount>>
  > = ({ signal }) => getAlumniSavedCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAlumniSavedCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAlumniSavedCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAlumniSavedCount>>
>;
export type GetAlumniSavedCountQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Count saved profiles for the authenticated verified alumni
 */

export function useGetAlumniSavedCount<
  TData = Awaited<ReturnType<typeof getAlumniSavedCount>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAlumniSavedCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAlumniSavedCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Saves an alumni profile to the authenticated verified alumni's shortlist. Idempotent. Returns savedCountBefore so the client can detect the first-ever save.
 * @summary Save a profile (alumni)
 */
export const getSaveAlumniProfileUrl = (profileId: number) => {
  return `/api/profiles/saved/${profileId}`;
};

export const saveAlumniProfile = async (
  profileId: number,
  options?: RequestInit,
): Promise<SaveProfileResponse> => {
  return customFetch<SaveProfileResponse>(getSaveAlumniProfileUrl(profileId), {
    ...options,
    method: "POST",
  });
};

export const getSaveAlumniProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAlumniProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveAlumniProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  const mutationKey = ["saveAlumniProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveAlumniProfile>>,
    { profileId: number }
  > = (props) => {
    const { profileId } = props ?? {};

    return saveAlumniProfile(profileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveAlumniProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveAlumniProfile>>
>;

export type SaveAlumniProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Save a profile (alumni)
 */
export const useSaveAlumniProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAlumniProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveAlumniProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  return useMutation(getSaveAlumniProfileMutationOptions(options));
};

/**
 * Removes an alumni profile from the authenticated verified alumni's shortlist.
 * @summary Unsave a profile (alumni)
 */
export const getUnsaveAlumniProfileUrl = (profileId: number) => {
  return `/api/profiles/saved/${profileId}`;
};

export const unsaveAlumniProfile = async (
  profileId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getUnsaveAlumniProfileUrl(profileId), {
    ...options,
    method: "DELETE",
  });
};

export const getUnsaveAlumniProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsaveAlumniProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unsaveAlumniProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  const mutationKey = ["unsaveAlumniProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unsaveAlumniProfile>>,
    { profileId: number }
  > = (props) => {
    const { profileId } = props ?? {};

    return unsaveAlumniProfile(profileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnsaveAlumniProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof unsaveAlumniProfile>>
>;

export type UnsaveAlumniProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Unsave a profile (alumni)
 */
export const useUnsaveAlumniProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unsaveAlumniProfile>>,
    TError,
    { profileId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unsaveAlumniProfile>>,
  TError,
  { profileId: number },
  TContext
> => {
  return useMutation(getUnsaveAlumniProfileMutationOptions(options));
};

/**
 * Public, unauthenticated one-click unsubscribe. Looks up the user or recruiter by the token stored in their `unsubscribe_token` column. If found, clears all email subscriptions for that entity and redirects to /unsubscribed. Always redirects to /unsubscribed regardless of token validity — no information is leaked about whether the token matched.

 * @summary Universal unsubscribe all
 */
export const getUnsubscribeAllUrl = (token: string) => {
  return `/api/unsubscribe/${token}`;
};

export const unsubscribeAll = async (
  token: string,
  options?: RequestInit,
): Promise<unknown> => {
  return customFetch<unknown>(getUnsubscribeAllUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getUnsubscribeAllQueryKey = (token: string) => {
  return [`/api/unsubscribe/${token}`] as const;
};

export const getUnsubscribeAllQueryOptions = <
  TData = Awaited<ReturnType<typeof unsubscribeAll>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof unsubscribeAll>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUnsubscribeAllQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof unsubscribeAll>>> = ({
    signal,
  }) => unsubscribeAll(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof unsubscribeAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UnsubscribeAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof unsubscribeAll>>
>;
export type UnsubscribeAllQueryError = ErrorType<void>;

/**
 * @summary Universal unsubscribe all
 */

export function useUnsubscribeAll<
  TData = Awaited<ReturnType<typeof unsubscribeAll>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof unsubscribeAll>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUnsubscribeAllQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all job posts ordered by most recent first. Supports server-side filtering by discipline tag.
 * @summary List all job posts
 */
export const getListJobsUrl = (params?: ListJobsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["industryTag"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : v.toString());
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/jobs?${stringifiedParams}`
    : `/api/jobs`;
};

export const listJobs = async (
  params?: ListJobsParams,
  options?: RequestInit,
): Promise<JobPost[]> => {
  return customFetch<JobPost[]>(getListJobsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListJobsQueryKey = (params?: ListJobsParams) => {
  return [`/api/jobs`, ...(params ? [params] : [])] as const;
};

export const getListJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listJobs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListJobsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListJobsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({
    signal,
  }) => listJobs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listJobs>>
>;
export type ListJobsQueryError = ErrorType<unknown>;

/**
 * @summary List all job posts
 */

export function useListJobs<
  TData = Awaited<ReturnType<typeof listJobs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListJobsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListJobsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new job post. Recruiter email must be a corporate domain.
 * @summary Post an opportunity
 */
export const getCreateJobUrl = () => {
  return `/api/jobs`;
};

export const createJob = async (
  createJobBody: CreateJobBody,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getCreateJobUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createJobBody),
  });
};

export const getCreateJobMutationOptions = <
  TError = ErrorType<ErrorResponse | EmailAccountExistsError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJob>>,
    TError,
    { data: BodyType<CreateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createJob>>,
  TError,
  { data: BodyType<CreateJobBody> },
  TContext
> => {
  const mutationKey = ["createJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createJob>>,
    { data: BodyType<CreateJobBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createJob(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof createJob>>
>;
export type CreateJobMutationBody = BodyType<CreateJobBody>;
export type CreateJobMutationError = ErrorType<
  ErrorResponse | EmailAccountExistsError
>;

/**
 * @summary Post an opportunity
 */
export const useCreateJob = <
  TError = ErrorType<ErrorResponse | EmailAccountExistsError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createJob>>,
    TError,
    { data: BodyType<CreateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createJob>>,
  TError,
  { data: BodyType<CreateJobBody> },
  TContext
> => {
  return useMutation(getCreateJobMutationOptions(options));
};

/**
 * Returns all job posts where authorId matches the calling user's session userId. Requires an active session. Returns the full managed job rows including managementToken.
 * @summary List job posts owned by the authenticated user
 */
export const getGetMyJobsUrl = () => {
  return `/api/jobs/mine`;
};

export const getMyJobs = async (
  options?: RequestInit,
): Promise<ManagedJobPost[]> => {
  return customFetch<ManagedJobPost[]>(getGetMyJobsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyJobsQueryKey = () => {
  return [`/api/jobs/mine`] as const;
};

export const getGetMyJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyJobs>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyJobsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyJobs>>> = ({
    signal,
  }) => getMyJobs({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyJobs>>
>;
export type GetMyJobsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List job posts owned by the authenticated user
 */

export function useGetMyJobs<
  TData = Awaited<ReturnType<typeof getMyJobs>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMyJobs>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyJobsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a single job post by its numeric ID. Returns 404 if not found or expired.
 * @summary Get a single job post by ID
 */
export const getGetJobUrl = (id: number) => {
  return `/api/jobs/${id}`;
};

export const getJob = async (
  id: number,
  options?: RequestInit,
): Promise<JobPost> => {
  return customFetch<JobPost>(getGetJobUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetJobQueryKey = (id: number) => {
  return [`/api/jobs/${id}`] as const;
};

export const getGetJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getJob>>,
  TError = ErrorType<JobNotFoundError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({
    signal,
  }) => getJob(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>;
export type GetJobQueryError = ErrorType<JobNotFoundError>;

/**
 * @summary Get a single job post by ID
 */

export function useGetJob<
  TData = Awaited<ReturnType<typeof getJob>>,
  TError = ErrorType<JobNotFoundError>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates a job post owned by the authenticated session user. Returns 401 if not authenticated, 403 if not the owner.
 * @summary Update a job post (session-owned)
 */
export const getUpdateJobUrl = (id: number) => {
  return `/api/jobs/${id}`;
};

export const updateJob = async (
  id: number,
  updateJobBody: UpdateJobBody,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getUpdateJobUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateJobBody),
  });
};

export const getUpdateJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJob>>,
    TError,
    { id: number; data: BodyType<UpdateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateJob>>,
  TError,
  { id: number; data: BodyType<UpdateJobBody> },
  TContext
> => {
  const mutationKey = ["updateJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateJob>>,
    { id: number; data: BodyType<UpdateJobBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateJob(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateJob>>
>;
export type UpdateJobMutationBody = BodyType<UpdateJobBody>;
export type UpdateJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a job post (session-owned)
 */
export const useUpdateJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJob>>,
    TError,
    { id: number; data: BodyType<UpdateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateJob>>,
  TError,
  { id: number; data: BodyType<UpdateJobBody> },
  TContext
> => {
  return useMutation(getUpdateJobMutationOptions(options));
};

/**
 * Deletes a job post owned by the authenticated session user. Returns 401 if not authenticated, 403 if not the owner.
 * @summary Delete a job post (session-owned)
 */
export const getDeleteJobUrl = (id: number) => {
  return `/api/jobs/${id}`;
};

export const deleteJob = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteJobUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJob>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJob>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteJob(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJob>>
>;

export type DeleteJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a job post (session-owned)
 */
export const useDeleteJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteJob>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteJobMutationOptions(options));
};

/**
 * Resets lastRenewedAt to now, extending the listing for another 30 days. Requires an active session and ownership. Returns 401 if not authenticated, 403 if not the owner.
 * @summary Renew a job listing (session-owned)
 */
export const getRenewJobUrl = (id: number) => {
  return `/api/jobs/${id}/renew`;
};

export const renewJob = async (
  id: number,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getRenewJobUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRenewJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renewJob>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["renewJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renewJob>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return renewJob(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenewJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof renewJob>>
>;

export type RenewJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Renew a job listing (session-owned)
 */
export const useRenewJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof renewJob>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getRenewJobMutationOptions(options));
};

/**
 * Sets status to "filled", hiding the listing from the public board. Requires an active session and ownership. Returns 401 if not authenticated, 403 if not the owner.
 * @summary Mark a job listing as filled (session-owned)
 */
export const getCloseJobUrl = (id: number) => {
  return `/api/jobs/${id}/close`;
};

export const closeJob = async (
  id: number,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getCloseJobUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCloseJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeJob>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["closeJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeJob>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return closeJob(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeJob>>
>;

export type CloseJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Mark a job listing as filled (session-owned)
 */
export const useCloseJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof closeJob>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getCloseJobMutationOptions(options));
};

/**
 * Looks up active job posts by the provided business email address and re-fires the MAKE_JOB_WEBHOOK_URL so Make.com can resend the management link email. Rate-limited to one resend per email per hour. Returns 200 whether or not a matching listing was found, to prevent email enumeration. Returns 400 for invalid input and 429 when rate-limited.

 * @summary Resend the management link to the recruiter's email
 */
export const getResendManagementLinkUrl = () => {
  return `/api/jobs/manage/resend`;
};

export const resendManagementLink = async (
  resendManagementLinkBody: ResendManagementLinkBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getResendManagementLinkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resendManagementLinkBody),
  });
};

export const getResendManagementLinkMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendManagementLink>>,
    TError,
    { data: BodyType<ResendManagementLinkBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendManagementLink>>,
  TError,
  { data: BodyType<ResendManagementLinkBody> },
  TContext
> => {
  const mutationKey = ["resendManagementLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendManagementLink>>,
    { data: BodyType<ResendManagementLinkBody> }
  > = (props) => {
    const { data } = props ?? {};

    return resendManagementLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendManagementLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendManagementLink>>
>;
export type ResendManagementLinkMutationBody =
  BodyType<ResendManagementLinkBody>;
export type ResendManagementLinkMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Resend the management link to the recruiter's email
 */
export const useResendManagementLink = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendManagementLink>>,
    TError,
    { data: BodyType<ResendManagementLinkBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendManagementLink>>,
  TError,
  { data: BodyType<ResendManagementLinkBody> },
  TContext
> => {
  return useMutation(getResendManagementLinkMutationOptions(options));
};

/**
 * Resets lastRenewedAt to now, extending the listing for another 30 days. No authentication required. Authenticated alumni who originally posted the listing can also renew via POST /jobs/{id}/renew using their session.
 * @summary Renew a job listing
 */
export const getRenewJobByManagementTokenUrl = (token: string) => {
  return `/api/jobs/manage/${token}/renew`;
};

export const renewJobByManagementToken = async (
  token: string,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getRenewJobByManagementTokenUrl(token), {
    ...options,
    method: "POST",
  });
};

export const getRenewJobByManagementTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewJobByManagementToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renewJobByManagementToken>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["renewJobByManagementToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renewJobByManagementToken>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return renewJobByManagementToken(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenewJobByManagementTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof renewJobByManagementToken>>
>;

export type RenewJobByManagementTokenMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Renew a job listing
 */
export const useRenewJobByManagementToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewJobByManagementToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof renewJobByManagementToken>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getRenewJobByManagementTokenMutationOptions(options));
};

/**
 * Sets status to "filled", hiding the listing from the public board without deleting it. No authentication required. Authenticated alumni who originally posted the listing can also close via POST /jobs/{id}/close using their session.
 * @summary Mark a job listing as filled
 */
export const getCloseJobByManagementTokenUrl = (token: string) => {
  return `/api/jobs/manage/${token}/close`;
};

export const closeJobByManagementToken = async (
  token: string,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getCloseJobByManagementTokenUrl(token), {
    ...options,
    method: "POST",
  });
};

export const getCloseJobByManagementTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeJobByManagementToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof closeJobByManagementToken>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["closeJobByManagementToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeJobByManagementToken>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return closeJobByManagementToken(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CloseJobByManagementTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof closeJobByManagementToken>>
>;

export type CloseJobByManagementTokenMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Mark a job listing as filled
 */
export const useCloseJobByManagementToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof closeJobByManagementToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof closeJobByManagementToken>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getCloseJobByManagementTokenMutationOptions(options));
};

/**
 * Retrieves a job post (including managementToken) using its management token. No authentication required.
 * @summary Get a job post by management token
 */
export const getGetJobByManagementTokenUrl = (token: string) => {
  return `/api/jobs/manage/${token}`;
};

export const getJobByManagementToken = async (
  token: string,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getGetJobByManagementTokenUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetJobByManagementTokenQueryKey = (token: string) => {
  return [`/api/jobs/manage/${token}`] as const;
};

export const getGetJobByManagementTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobByManagementToken>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobByManagementToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetJobByManagementTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobByManagementToken>>
  > = ({ signal }) =>
    getJobByManagementToken(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobByManagementToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobByManagementTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobByManagementToken>>
>;
export type GetJobByManagementTokenQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a job post by management token
 */

export function useGetJobByManagementToken<
  TData = Awaited<ReturnType<typeof getJobByManagementToken>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getJobByManagementToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobByManagementTokenQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates a job post using its management token. No authentication required. Authenticated alumni who originally posted the listing can also update via PUT /jobs/{id} using their session.
 * @summary Update a job post by management token
 */
export const getUpdateJobByManagementTokenUrl = (token: string) => {
  return `/api/jobs/manage/${token}`;
};

export const updateJobByManagementToken = async (
  token: string,
  updateJobBody: UpdateJobBody,
  options?: RequestInit,
): Promise<ManagedJobPost> => {
  return customFetch<ManagedJobPost>(getUpdateJobByManagementTokenUrl(token), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateJobBody),
  });
};

export const getUpdateJobByManagementTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJobByManagementToken>>,
    TError,
    { token: string; data: BodyType<UpdateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateJobByManagementToken>>,
  TError,
  { token: string; data: BodyType<UpdateJobBody> },
  TContext
> => {
  const mutationKey = ["updateJobByManagementToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateJobByManagementToken>>,
    { token: string; data: BodyType<UpdateJobBody> }
  > = (props) => {
    const { token, data } = props ?? {};

    return updateJobByManagementToken(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateJobByManagementTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateJobByManagementToken>>
>;
export type UpdateJobByManagementTokenMutationBody = BodyType<UpdateJobBody>;
export type UpdateJobByManagementTokenMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a job post by management token
 */
export const useUpdateJobByManagementToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateJobByManagementToken>>,
    TError,
    { token: string; data: BodyType<UpdateJobBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateJobByManagementToken>>,
  TError,
  { token: string; data: BodyType<UpdateJobBody> },
  TContext
> => {
  return useMutation(getUpdateJobByManagementTokenMutationOptions(options));
};

/**
 * Deletes a job post using its management token. No authentication required. Authenticated alumni who originally posted the listing can also delete via DELETE /jobs/{id} using their session.
 * @summary Delete a job post by management token
 */
export const getDeleteJobByManagementTokenUrl = (token: string) => {
  return `/api/jobs/manage/${token}`;
};

export const deleteJobByManagementToken = async (
  token: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteJobByManagementTokenUrl(token), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteJobByManagementTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobByManagementToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteJobByManagementToken>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["deleteJobByManagementToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteJobByManagementToken>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return deleteJobByManagementToken(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteJobByManagementTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteJobByManagementToken>>
>;

export type DeleteJobByManagementTokenMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a job post by management token
 */
export const useDeleteJobByManagementToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteJobByManagementToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteJobByManagementToken>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getDeleteJobByManagementTokenMutationOptions(options));
};

/**
 * Returns all profiles including unverified. Requires admin token.
 * @summary List all profiles for admin (pending + verified)
 */
export const getListAdminProfilesUrl = (params?: ListAdminProfilesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/profiles?${stringifiedParams}`
    : `/api/admin/profiles`;
};

export const listAdminProfiles = async (
  params?: ListAdminProfilesParams,
  options?: RequestInit,
): Promise<AdminProfile[]> => {
  return customFetch<AdminProfile[]>(getListAdminProfilesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminProfilesQueryKey = (
  params?: ListAdminProfilesParams,
) => {
  return [`/api/admin/profiles`, ...(params ? [params] : [])] as const;
};

export const getListAdminProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAdminProfilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAdminProfiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminProfilesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminProfiles>>
  > = ({ signal }) => listAdminProfiles(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminProfiles>>
>;
export type ListAdminProfilesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all profiles for admin (pending + verified)
 */

export function useListAdminProfiles<
  TData = Awaited<ReturnType<typeof listAdminProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAdminProfilesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAdminProfiles>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminProfilesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all profiles (verified, pending, and resubmitted) capped at 200, newest first. Requires admin token.
 * @summary List all profiles regardless of status
 */
export const getListAdminProfilesAllUrl = () => {
  return `/api/admin/profiles/all`;
};

export const listAdminProfilesAll = async (
  options?: RequestInit,
): Promise<AdminAllProfile[]> => {
  return customFetch<AdminAllProfile[]>(getListAdminProfilesAllUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminProfilesAllQueryKey = () => {
  return [`/api/admin/profiles/all`] as const;
};

export const getListAdminProfilesAllQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminProfilesAll>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminProfilesAll>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminProfilesAllQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminProfilesAll>>
  > = ({ signal }) => listAdminProfilesAll({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminProfilesAll>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminProfilesAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminProfilesAll>>
>;
export type ListAdminProfilesAllQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all profiles regardless of status
 */

export function useListAdminProfilesAll<
  TData = Awaited<ReturnType<typeof listAdminProfilesAll>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminProfilesAll>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminProfilesAllQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sets requiresRevision=true and verified=false on the profile without deleting any content. An optional comment is saved to tell the alumni what to fix. Fires MAKE_RESUBMIT_WEBHOOK_URL and records a profile_resubmitted audit log entry. Requires admin token.
 * @summary Flag a profile for revision (soft reject)
 */
export const getResubmitProfileUrl = (id: number) => {
  return `/api/admin/profiles/${id}/resubmit`;
};

export const resubmitProfile = async (
  id: number,
  resubmitProfileBody?: ResubmitProfileBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getResubmitProfileUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resubmitProfileBody),
  });
};

export const getResubmitProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resubmitProfile>>,
    TError,
    { id: number; data: BodyType<ResubmitProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resubmitProfile>>,
  TError,
  { id: number; data: BodyType<ResubmitProfileBody> },
  TContext
> => {
  const mutationKey = ["resubmitProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resubmitProfile>>,
    { id: number; data: BodyType<ResubmitProfileBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resubmitProfile(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResubmitProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof resubmitProfile>>
>;
export type ResubmitProfileMutationBody = BodyType<ResubmitProfileBody>;
export type ResubmitProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Flag a profile for revision (soft reject)
 */
export const useResubmitProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resubmitProfile>>,
    TError,
    { id: number; data: BodyType<ResubmitProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resubmitProfile>>,
  TError,
  { id: number; data: BodyType<ResubmitProfileBody> },
  TContext
> => {
  return useMutation(getResubmitProfileMutationOptions(options));
};

/**
 * Returns all verification-related audit log entries for a specific profile (verification_change, user_verified, profile_resubmitted), ordered newest first. Requires admin token.
 * @summary Get verification audit log for a profile
 */
export const getGetAdminProfileAuditLogUrl = (id: number) => {
  return `/api/admin/profiles/${id}/audit-log`;
};

export const getAdminProfileAuditLog = async (
  id: number,
  options?: RequestInit,
): Promise<VerificationAuditLogEntry[]> => {
  return customFetch<VerificationAuditLogEntry[]>(
    getGetAdminProfileAuditLogUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminProfileAuditLogQueryKey = (id: number) => {
  return [`/api/admin/profiles/${id}/audit-log`] as const;
};

export const getGetAdminProfileAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminProfileAuditLog>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminProfileAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminProfileAuditLogQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminProfileAuditLog>>
  > = ({ signal }) =>
    getAdminProfileAuditLog(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminProfileAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminProfileAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminProfileAuditLog>>
>;
export type GetAdminProfileAuditLogQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get verification audit log for a profile
 */

export function useGetAdminProfileAuditLog<
  TData = Awaited<ReturnType<typeof getAdminProfileAuditLog>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminProfileAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminProfileAuditLogQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Sets verified=true on the profile. Requires admin token.
 * @summary Approve a pending profile
 */
export const getApproveProfileUrl = (id: number) => {
  return `/api/admin/profiles/${id}/approve`;
};

export const approveProfile = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getApproveProfileUrl(id), {
    ...options,
    method: "PATCH",
  });
};

export const getApproveProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveProfile>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["approveProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveProfile>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return approveProfile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveProfile>>
>;

export type ApproveProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Approve a pending profile
 */
export const useApproveProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveProfile>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getApproveProfileMutationOptions(options));
};

/**
 * Deletes the custom avatar object and reverts the profile to the retained OAuth avatar (or no avatar). Requires admin token.
 * @summary Clear a member's custom avatar
 */
export const getClearAdminProfileAvatarUrl = (id: number) => {
  return `/api/admin/profiles/${id}/avatar`;
};

export const clearAdminProfileAvatar = async (
  id: number,
  options?: RequestInit,
): Promise<AvatarResponse> => {
  return customFetch<AvatarResponse>(getClearAdminProfileAvatarUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getClearAdminProfileAvatarMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearAdminProfileAvatar>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clearAdminProfileAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["clearAdminProfileAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clearAdminProfileAvatar>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return clearAdminProfileAvatar(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClearAdminProfileAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof clearAdminProfileAvatar>>
>;

export type ClearAdminProfileAvatarMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Clear a member's custom avatar
 */
export const useClearAdminProfileAvatar = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clearAdminProfileAvatar>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof clearAdminProfileAvatar>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getClearAdminProfileAvatarMutationOptions(options));
};

/**
 * Manually verify or un-verify an alumni profile. Requires admin token.
 * @summary Set profile verified status
 */
export const getSetProfileVerifiedUrl = (id: number) => {
  return `/api/admin/profiles/${id}`;
};

export const setProfileVerified = async (
  id: number,
  setProfileVerifiedBody: SetProfileVerifiedBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getSetProfileVerifiedUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setProfileVerifiedBody),
  });
};

export const getSetProfileVerifiedMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setProfileVerified>>,
    TError,
    { id: number; data: BodyType<SetProfileVerifiedBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setProfileVerified>>,
  TError,
  { id: number; data: BodyType<SetProfileVerifiedBody> },
  TContext
> => {
  const mutationKey = ["setProfileVerified"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setProfileVerified>>,
    { id: number; data: BodyType<SetProfileVerifiedBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return setProfileVerified(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetProfileVerifiedMutationResult = NonNullable<
  Awaited<ReturnType<typeof setProfileVerified>>
>;
export type SetProfileVerifiedMutationBody = BodyType<SetProfileVerifiedBody>;
export type SetProfileVerifiedMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Set profile verified status
 */
export const useSetProfileVerified = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setProfileVerified>>,
    TError,
    { id: number; data: BodyType<SetProfileVerifiedBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setProfileVerified>>,
  TError,
  { id: number; data: BodyType<SetProfileVerifiedBody> },
  TContext
> => {
  return useMutation(getSetProfileVerifiedMutationOptions(options));
};

/**
 * Permanently removes a profile. Requires admin token.
 * @summary Delete a profile
 */
export const getDeleteAdminProfileUrl = (id: number) => {
  return `/api/admin/profiles/${id}`;
};

export const deleteAdminProfile = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteAdminProfileUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminProfile>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminProfile>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminProfile(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminProfile>>
>;

export type DeleteAdminProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a profile
 */
export const useDeleteAdminProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminProfile>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminProfile>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAdminProfileMutationOptions(options));
};

/**
 * Returns all submitted profile reports. Requires admin token.
 * @summary List all profile reports
 */
export const getListAdminReportsUrl = () => {
  return `/api/admin/reports`;
};

export const listAdminReports = async (
  options?: RequestInit,
): Promise<AdminReport[]> => {
  return customFetch<AdminReport[]>(getListAdminReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminReportsQueryKey = () => {
  return [`/api/admin/reports`] as const;
};

export const getListAdminReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminReportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminReports>>
  > = ({ signal }) => listAdminReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminReports>>
>;
export type ListAdminReportsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all profile reports
 */

export function useListAdminReports<
  TData = Awaited<ReturnType<typeof listAdminReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns all feature comments that have been reported, grouped by comment, with reporter count. Requires admin token.
 * @summary List reported feature comments
 */
export const getListAdminFeatureCommentReportsUrl = () => {
  return `/api/admin/feature-comment-reports`;
};

export const listAdminFeatureCommentReports = async (
  options?: RequestInit,
): Promise<CommentReportItem[]> => {
  return customFetch<CommentReportItem[]>(
    getListAdminFeatureCommentReportsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminFeatureCommentReportsQueryKey = () => {
  return [`/api/admin/feature-comment-reports`] as const;
};

export const getListAdminFeatureCommentReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminFeatureCommentReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminFeatureCommentReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminFeatureCommentReportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminFeatureCommentReports>>
  > = ({ signal }) =>
    listAdminFeatureCommentReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminFeatureCommentReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminFeatureCommentReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminFeatureCommentReports>>
>;
export type ListAdminFeatureCommentReportsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List reported feature comments
 */

export function useListAdminFeatureCommentReports<
  TData = Awaited<ReturnType<typeof listAdminFeatureCommentReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminFeatureCommentReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminFeatureCommentReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Deletes all rows in feature_comment_reports for the given comment without deleting the comment itself. Requires admin token.
 * @summary Dismiss all reports for a comment
 */
export const getDismissAdminFeatureCommentReportsUrl = (commentId: number) => {
  return `/api/admin/feature-comment-reports/${commentId}`;
};

export const dismissAdminFeatureCommentReports = async (
  commentId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(
    getDismissAdminFeatureCommentReportsUrl(commentId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDismissAdminFeatureCommentReportsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAdminFeatureCommentReports>>,
    TError,
    { commentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissAdminFeatureCommentReports>>,
  TError,
  { commentId: number },
  TContext
> => {
  const mutationKey = ["dismissAdminFeatureCommentReports"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissAdminFeatureCommentReports>>,
    { commentId: number }
  > = (props) => {
    const { commentId } = props ?? {};

    return dismissAdminFeatureCommentReports(commentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissAdminFeatureCommentReportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissAdminFeatureCommentReports>>
>;

export type DismissAdminFeatureCommentReportsMutationError =
  ErrorType<ErrorResponse>;

/**
 * @summary Dismiss all reports for a comment
 */
export const useDismissAdminFeatureCommentReports = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAdminFeatureCommentReports>>,
    TError,
    { commentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissAdminFeatureCommentReports>>,
  TError,
  { commentId: number },
  TContext
> => {
  return useMutation(
    getDismissAdminFeatureCommentReportsMutationOptions(options),
  );
};

/**
 * Returns all submitted job post reports. Requires admin token.
 * @summary List all job post reports
 */
export const getListAdminJobReportsUrl = () => {
  return `/api/admin/job-reports`;
};

export const listAdminJobReports = async (
  options?: RequestInit,
): Promise<AdminJobReport[]> => {
  return customFetch<AdminJobReport[]>(getListAdminJobReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAdminJobReportsQueryKey = () => {
  return [`/api/admin/job-reports`] as const;
};

export const getListAdminJobReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminJobReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminJobReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminJobReportsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminJobReports>>
  > = ({ signal }) => listAdminJobReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminJobReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminJobReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminJobReports>>
>;
export type ListAdminJobReportsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all job post reports
 */

export function useListAdminJobReports<
  TData = Awaited<ReturnType<typeof listAdminJobReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAdminJobReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminJobReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Deletes a single job post report record (dismiss action). Requires admin token.
 * @summary Dismiss a job post report
 */
export const getDismissAdminJobReportUrl = (id: number) => {
  return `/api/admin/job-reports/${id}`;
};

export const dismissAdminJobReport = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDismissAdminJobReportUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDismissAdminJobReportMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAdminJobReport>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissAdminJobReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["dismissAdminJobReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissAdminJobReport>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return dismissAdminJobReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissAdminJobReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissAdminJobReport>>
>;

export type DismissAdminJobReportMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Dismiss a job post report
 */
export const useDismissAdminJobReport = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissAdminJobReport>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissAdminJobReport>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDismissAdminJobReportMutationOptions(options));
};

/**
 * Permanently removes a job post. Requires admin token.
 * @summary Delete a job post (admin)
 */
export const getDeleteAdminJobUrl = (id: number) => {
  return `/api/admin/jobs/${id}`;
};

export const deleteAdminJob = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteAdminJobUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminJobMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminJob>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminJob>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminJob(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminJob>>
>;

export type DeleteAdminJobMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a job post (admin)
 */
export const useDeleteAdminJob = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminJob>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminJob>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAdminJobMutationOptions(options));
};

/**
 * Returns all community/event posts ordered by reportCount descending. Supports filtering by type and status. Requires admin token.
 * @summary List community posts for admin moderation
 */
export const getListAdminCommunityPostsUrl = (
  params?: ListAdminCommunityPostsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/community-posts?${stringifiedParams}`
    : `/api/admin/community-posts`;
};

export const listAdminCommunityPosts = async (
  params?: ListAdminCommunityPostsParams,
  options?: RequestInit,
): Promise<CommunityEventPost[]> => {
  return customFetch<CommunityEventPost[]>(
    getListAdminCommunityPostsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAdminCommunityPostsQueryKey = (
  params?: ListAdminCommunityPostsParams,
) => {
  return [`/api/admin/community-posts`, ...(params ? [params] : [])] as const;
};

export const getListAdminCommunityPostsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminCommunityPosts>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAdminCommunityPostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAdminCommunityPosts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAdminCommunityPostsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminCommunityPosts>>
  > = ({ signal }) =>
    listAdminCommunityPosts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminCommunityPosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminCommunityPostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminCommunityPosts>>
>;
export type ListAdminCommunityPostsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List community posts for admin moderation
 */

export function useListAdminCommunityPosts<
  TData = Awaited<ReturnType<typeof listAdminCommunityPosts>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAdminCommunityPostsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAdminCommunityPosts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminCommunityPostsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Toggles the hidden status of a community post. Requires admin token.
 * @summary Update a community post (admin)
 */
export const getPatchAdminCommunityPostUrl = (id: number) => {
  return `/api/admin/community-posts/${id}`;
};

export const patchAdminCommunityPost = async (
  id: number,
  patchAdminCommunityPostBody: PatchAdminCommunityPostBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getPatchAdminCommunityPostUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(patchAdminCommunityPostBody),
  });
};

export const getPatchAdminCommunityPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAdminCommunityPost>>,
    TError,
    { id: number; data: BodyType<PatchAdminCommunityPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchAdminCommunityPost>>,
  TError,
  { id: number; data: BodyType<PatchAdminCommunityPostBody> },
  TContext
> => {
  const mutationKey = ["patchAdminCommunityPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchAdminCommunityPost>>,
    { id: number; data: BodyType<PatchAdminCommunityPostBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchAdminCommunityPost(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchAdminCommunityPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchAdminCommunityPost>>
>;
export type PatchAdminCommunityPostMutationBody =
  BodyType<PatchAdminCommunityPostBody>;
export type PatchAdminCommunityPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a community post (admin)
 */
export const usePatchAdminCommunityPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchAdminCommunityPost>>,
    TError,
    { id: number; data: BodyType<PatchAdminCommunityPostBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchAdminCommunityPost>>,
  TError,
  { id: number; data: BodyType<PatchAdminCommunityPostBody> },
  TContext
> => {
  return useMutation(getPatchAdminCommunityPostMutationOptions(options));
};

/**
 * Permanently removes a community/event post regardless of author. Requires admin token.
 * @summary Delete a community post (admin)
 */
export const getDeleteAdminCommunityPostUrl = (id: number) => {
  return `/api/admin/community-posts/${id}`;
};

export const deleteAdminCommunityPost = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteAdminCommunityPostUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminCommunityPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminCommunityPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminCommunityPost>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminCommunityPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminCommunityPost>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminCommunityPost(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminCommunityPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminCommunityPost>>
>;

export type DeleteAdminCommunityPostMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a community post (admin)
 */
export const useDeleteAdminCommunityPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminCommunityPost>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminCommunityPost>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAdminCommunityPostMutationOptions(options));
};

/**
 * Records a client-side event. Identity fields are derived from the server session — never sent by the client. Fails open (always returns 204). Rate-limited to 60 requests per minute per IP.
 * @summary Track a client-side event
 */
export const getTrackEventUrl = () => {
  return `/api/analytics/track`;
};

export const trackEvent = async (
  trackEventBody: TrackEventBody,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getTrackEventUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(trackEventBody),
  });
};

export const getTrackEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackEvent>>,
    TError,
    { data: BodyType<TrackEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof trackEvent>>,
  TError,
  { data: BodyType<TrackEventBody> },
  TContext
> => {
  const mutationKey = ["trackEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof trackEvent>>,
    { data: BodyType<TrackEventBody> }
  > = (props) => {
    const { data } = props ?? {};

    return trackEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TrackEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof trackEvent>>
>;
export type TrackEventMutationBody = BodyType<TrackEventBody>;
export type TrackEventMutationError = ErrorType<unknown>;

/**
 * @summary Track a client-side event
 */
export const useTrackEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof trackEvent>>,
    TError,
    { data: BodyType<TrackEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof trackEvent>>,
  TError,
  { data: BodyType<TrackEventBody> },
  TContext
> => {
  return useMutation(getTrackEventMutationOptions(options));
};

/**
 * Returns aggregate survey stats, a monthly response-rate timeline, and individual responses (admin-only; includes profile ID and name). Requires admin token or admin role session.
 * @summary Get OtW success survey results
 */
export const getGetAdminSurveyResultsUrl = () => {
  return `/api/admin/survey-results`;
};

export const getAdminSurveyResults = async (
  options?: RequestInit,
): Promise<SurveyResultsResponse> => {
  return customFetch<SurveyResultsResponse>(getGetAdminSurveyResultsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminSurveyResultsQueryKey = () => {
  return [`/api/admin/survey-results`] as const;
};

export const getGetAdminSurveyResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminSurveyResults>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSurveyResults>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminSurveyResultsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminSurveyResults>>
  > = ({ signal }) => getAdminSurveyResults({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSurveyResults>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminSurveyResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSurveyResults>>
>;
export type GetAdminSurveyResultsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get OtW success survey results
 */

export function useGetAdminSurveyResults<
  TData = Awaited<ReturnType<typeof getAdminSurveyResults>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSurveyResults>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminSurveyResultsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns 52-week activity series, cumulative member growth, event totals, and summary stats. Requires admin token or admin role session.
 * @summary Get analytics dashboard data
 */
export const getGetAdminAnalyticsUrl = (params?: GetAdminAnalyticsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/analytics?${stringifiedParams}`
    : `/api/admin/analytics`;
};

export const getAdminAnalytics = async (
  params?: GetAdminAnalyticsParams,
  options?: RequestInit,
): Promise<AnalyticsResponse> => {
  return customFetch<AnalyticsResponse>(getGetAdminAnalyticsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminAnalyticsQueryKey = (
  params?: GetAdminAnalyticsParams,
) => {
  return [`/api/admin/analytics`, ...(params ? [params] : [])] as const;
};

export const getGetAdminAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminAnalytics>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetAdminAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminAnalytics>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminAnalyticsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminAnalytics>>
  > = ({ signal }) => getAdminAnalytics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminAnalytics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminAnalytics>>
>;
export type GetAdminAnalyticsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get analytics dashboard data
 */

export function useGetAdminAnalytics<
  TData = Awaited<ReturnType<typeof getAdminAnalytics>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetAdminAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminAnalytics>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminAnalyticsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a paginated list of users for the Permissions tab. Supports optional case-insensitive substring search by email or display name. Requires admin token or admin role session.
 * @summary List all users with their roles
 */
export const getListAdminUsersUrl = (params?: ListAdminUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/users?${stringifiedParams}`
    : `/api/admin/users`;
};

export const listAdminUsers = async (
  params?: ListAdminUsersParams,
  options?: RequestInit,
): Promise<AdminUserList> => {
  return customFetch<AdminUserList>(getListAdminUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAdminUsersQueryKey = (params?: ListAdminUsersParams) => {
  return [`/api/admin/users`, ...(params ? [params] : [])] as const;
};

export const getListAdminUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminUsers>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAdminUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAdminUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAdminUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminUsers>>> = ({
    signal,
  }) => listAdminUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAdminUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminUsers>>
>;
export type ListAdminUsersQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List all users with their roles
 */

export function useListAdminUsers<
  TData = Awaited<ReturnType<typeof listAdminUsers>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAdminUsersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAdminUsers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAdminUsersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Changes the role of a user account. The change takes effect on the user's next request. Requires admin token or admin role session.
 * @summary Update a user's role
 */
export const getUpdateUserRoleUrl = (id: number) => {
  return `/api/admin/users/${id}/role`;
};

export const updateUserRole = async (
  id: number,
  updateUserRoleBody: UpdateUserRoleBody,
  options?: RequestInit,
): Promise<AdminUser> => {
  return customFetch<AdminUser>(getUpdateUserRoleUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateUserRoleBody),
  });
};

export const getUpdateUserRoleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserRole>>,
    TError,
    { id: number; data: BodyType<UpdateUserRoleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserRole>>,
  TError,
  { id: number; data: BodyType<UpdateUserRoleBody> },
  TContext
> => {
  const mutationKey = ["updateUserRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserRole>>,
    { id: number; data: BodyType<UpdateUserRoleBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateUserRole(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserRole>>
>;
export type UpdateUserRoleMutationBody = BodyType<UpdateUserRoleBody>;
export type UpdateUserRoleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a user's role
 */
export const useUpdateUserRole = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserRole>>,
    TError,
    { id: number; data: BodyType<UpdateUserRoleBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateUserRole>>,
  TError,
  { id: number; data: BodyType<UpdateUserRoleBody> },
  TContext
> => {
  return useMutation(getUpdateUserRoleMutationOptions(options));
};

/**
 * Returns boolean flags indicating whether each Make.com webhook URL is configured. Requires admin token.
 * @summary Get webhook configuration status
 */
export const getGetWebhookStatusUrl = () => {
  return `/api/admin/webhook-status`;
};

export const getWebhookStatus = async (
  options?: RequestInit,
): Promise<WebhookStatus> => {
  return customFetch<WebhookStatus>(getGetWebhookStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWebhookStatusQueryKey = () => {
  return [`/api/admin/webhook-status`] as const;
};

export const getGetWebhookStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getWebhookStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWebhookStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWebhookStatus>>
  > = ({ signal }) => getWebhookStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWebhookStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWebhookStatus>>
>;
export type GetWebhookStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get webhook configuration status
 */

export function useGetWebhookStatus<
  TData = Awaited<ReturnType<typeof getWebhookStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWebhookStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWebhookStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns boolean flags indicating whether each optional env var group is configured. No actual values are exposed. Requires admin token.
 * @summary Get environment variable configuration status
 */
export const getGetEnvStatusUrl = () => {
  return `/api/admin/env-status`;
};

export const getEnvStatus = async (
  options?: RequestInit,
): Promise<EnvStatus> => {
  return customFetch<EnvStatus>(getGetEnvStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetEnvStatusQueryKey = () => {
  return [`/api/admin/env-status`] as const;
};

export const getGetEnvStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnvStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnvStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnvStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnvStatus>>> = ({
    signal,
  }) => getEnvStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnvStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEnvStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnvStatus>>
>;
export type GetEnvStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get environment variable configuration status
 */

export function useGetEnvStatus<
  TData = Awaited<ReturnType<typeof getEnvStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getEnvStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEnvStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Deletes a report record (dismiss action). Requires admin token.
 * @summary Dismiss a report
 */
export const getDeleteAdminReportUrl = (id: number) => {
  return `/api/admin/reports/${id}`;
};

export const deleteAdminReport = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteAdminReportUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAdminReportMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminReport>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAdminReport>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteAdminReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAdminReport>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAdminReport(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAdminReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAdminReport>>
>;

export type DeleteAdminReportMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Dismiss a report
 */
export const useDeleteAdminReport = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAdminReport>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAdminReport>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteAdminReportMutationOptions(options));
};

/**
 * Returns webhook audit log entries ordered by newest first with optional filtering and pagination. Requires admin token.
 * @summary List webhook audit log entries
 */
export const getListWebhookAuditLogUrl = (
  params?: ListWebhookAuditLogParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/webhook-audit-log?${stringifiedParams}`
    : `/api/admin/webhook-audit-log`;
};

export const listWebhookAuditLog = async (
  params?: ListWebhookAuditLogParams,
  options?: RequestInit,
): Promise<WebhookAuditLogPage> => {
  return customFetch<WebhookAuditLogPage>(getListWebhookAuditLogUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListWebhookAuditLogQueryKey = (
  params?: ListWebhookAuditLogParams,
) => {
  return [`/api/admin/webhook-audit-log`, ...(params ? [params] : [])] as const;
};

export const getListWebhookAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listWebhookAuditLog>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListWebhookAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWebhookAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListWebhookAuditLogQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWebhookAuditLog>>
  > = ({ signal }) =>
    listWebhookAuditLog(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWebhookAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListWebhookAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listWebhookAuditLog>>
>;
export type ListWebhookAuditLogQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List webhook audit log entries
 */

export function useListWebhookAuditLog<
  TData = Awaited<ReturnType<typeof listWebhookAuditLog>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListWebhookAuditLogParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listWebhookAuditLog>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListWebhookAuditLogQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns recent admin verification change entries ordered by newest first. Requires admin token.
 * @summary List verification audit log entries
 */
export const getListVerificationAuditLogUrl = () => {
  return `/api/admin/verification-audit-log`;
};

export const listVerificationAuditLog = async (
  options?: RequestInit,
): Promise<VerificationAuditLogEntry[]> => {
  return customFetch<VerificationAuditLogEntry[]>(
    getListVerificationAuditLogUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListVerificationAuditLogQueryKey = () => {
  return [`/api/admin/verification-audit-log`] as const;
};

export const getListVerificationAuditLogQueryOptions = <
  TData = Awaited<ReturnType<typeof listVerificationAuditLog>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listVerificationAuditLog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVerificationAuditLogQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVerificationAuditLog>>
  > = ({ signal }) => listVerificationAuditLog({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVerificationAuditLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVerificationAuditLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVerificationAuditLog>>
>;
export type ListVerificationAuditLogQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List verification audit log entries
 */

export function useListVerificationAuditLog<
  TData = Awaited<ReturnType<typeof listVerificationAuditLog>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listVerificationAuditLog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVerificationAuditLogQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Fires a mock payload to MAKE_JOB_POSTED_WEBHOOK_URL to verify end-to-end email delivery. Requires admin token.
 * @summary Test the transactional email webhook
 */
export const getTestAdminEmailUrl = () => {
  return `/api/admin/test-email`;
};

export const testAdminEmail = async (
  testEmailBody: TestEmailBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getTestAdminEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(testEmailBody),
  });
};

export const getTestAdminEmailMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminEmail>>,
    TError,
    { data: BodyType<TestEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAdminEmail>>,
  TError,
  { data: BodyType<TestEmailBody> },
  TContext
> => {
  const mutationKey = ["testAdminEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAdminEmail>>,
    { data: BodyType<TestEmailBody> }
  > = (props) => {
    const { data } = props ?? {};

    return testAdminEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAdminEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof testAdminEmail>>
>;
export type TestAdminEmailMutationBody = BodyType<TestEmailBody>;
export type TestAdminEmailMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Test the transactional email webhook
 */
export const useTestAdminEmail = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminEmail>>,
    TError,
    { data: BodyType<TestEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testAdminEmail>>,
  TError,
  { data: BodyType<TestEmailBody> },
  TContext
> => {
  return useMutation(getTestAdminEmailMutationOptions(options));
};

/**
 * Fires a mock payload to MAKE_USER_VERIFIED_WEBHOOK_URL to verify end-to-end welcome email delivery. Requires admin token.
 * @summary Test the welcome email webhook
 */
export const getTestAdminWelcomeEmailUrl = () => {
  return `/api/admin/test-welcome-email`;
};

export const testAdminWelcomeEmail = async (
  testEmailBody: TestEmailBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getTestAdminWelcomeEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(testEmailBody),
  });
};

export const getTestAdminWelcomeEmailMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminWelcomeEmail>>,
    TError,
    { data: BodyType<TestEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAdminWelcomeEmail>>,
  TError,
  { data: BodyType<TestEmailBody> },
  TContext
> => {
  const mutationKey = ["testAdminWelcomeEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAdminWelcomeEmail>>,
    { data: BodyType<TestEmailBody> }
  > = (props) => {
    const { data } = props ?? {};

    return testAdminWelcomeEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAdminWelcomeEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof testAdminWelcomeEmail>>
>;
export type TestAdminWelcomeEmailMutationBody = BodyType<TestEmailBody>;
export type TestAdminWelcomeEmailMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Test the welcome email webhook
 */
export const useTestAdminWelcomeEmail = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminWelcomeEmail>>,
    TError,
    { data: BodyType<TestEmailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testAdminWelcomeEmail>>,
  TError,
  { data: BodyType<TestEmailBody> },
  TContext
> => {
  return useMutation(getTestAdminWelcomeEmailMutationOptions(options));
};

/**
 * Fires a mock Community Event payload to MAKE_COMMUNITY_WEBHOOK_URL. The bcc_emails array contains ONLY the authenticated admin's email — subscription tables are not queried.
 * @summary Test the community-event fan-out webhook
 */
export const getTestAdminCommunityWebhookUrl = () => {
  return `/api/admin/webhooks/test-community`;
};

export const testAdminCommunityWebhook = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getTestAdminCommunityWebhookUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTestAdminCommunityWebhookMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminCommunityWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAdminCommunityWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["testAdminCommunityWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAdminCommunityWebhook>>,
    void
  > = () => {
    return testAdminCommunityWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAdminCommunityWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof testAdminCommunityWebhook>>
>;

export type TestAdminCommunityWebhookMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Test the community-event fan-out webhook
 */
export const useTestAdminCommunityWebhook = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminCommunityWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testAdminCommunityWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTestAdminCommunityWebhookMutationOptions(options));
};

/**
 * Fires a mock Job payload to MAKE_JOB_WEBHOOK_URL. The bcc_emails array contains ONLY the authenticated admin's email — subscription tables are not queried.
 * @summary Test the job-post fan-out webhook
 */
export const getTestAdminJobWebhookUrl = () => {
  return `/api/admin/webhooks/test-job`;
};

export const testAdminJobWebhook = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getTestAdminJobWebhookUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTestAdminJobWebhookMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminJobWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAdminJobWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["testAdminJobWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAdminJobWebhook>>,
    void
  > = () => {
    return testAdminJobWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAdminJobWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof testAdminJobWebhook>>
>;

export type TestAdminJobWebhookMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Test the job-post fan-out webhook
 */
export const useTestAdminJobWebhook = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminJobWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testAdminJobWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTestAdminJobWebhookMutationOptions(options));
};

/**
 * Fires a mock Candidate payload to MAKE_CANDIDATE_WEBHOOK_URL. The bcc_emails array contains ONLY the authenticated admin's email — saved-profile and subscription tables are not queried.
 * @summary Test the candidate Open-to-Work fan-out webhook
 */
export const getTestAdminCandidateWebhookUrl = () => {
  return `/api/admin/webhooks/test-candidate`;
};

export const testAdminCandidateWebhook = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getTestAdminCandidateWebhookUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTestAdminCandidateWebhookMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminCandidateWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testAdminCandidateWebhook>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["testAdminCandidateWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testAdminCandidateWebhook>>,
    void
  > = () => {
    return testAdminCandidateWebhook(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestAdminCandidateWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof testAdminCandidateWebhook>>
>;

export type TestAdminCandidateWebhookMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Test the candidate Open-to-Work fan-out webhook
 */
export const useTestAdminCandidateWebhook = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testAdminCandidateWebhook>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testAdminCandidateWebhook>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTestAdminCandidateWebhookMutationOptions(options));
};

/**
 * Returns all feature requests sorted by upvotes descending. Includes hasVoted for authenticated callers.
 * @summary List all feature requests
 */
export const getListFeaturesUrl = () => {
  return `/api/features`;
};

export const listFeatures = async (
  options?: RequestInit,
): Promise<FeatureRequestItem[]> => {
  return customFetch<FeatureRequestItem[]>(getListFeaturesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListFeaturesQueryKey = () => {
  return [`/api/features`] as const;
};

export const getListFeaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFeatures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFeatures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFeaturesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeatures>>> = ({
    signal,
  }) => listFeatures({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFeatures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFeaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFeatures>>
>;
export type ListFeaturesQueryError = ErrorType<unknown>;

/**
 * @summary List all feature requests
 */

export function useListFeatures<
  TData = Awaited<ReturnType<typeof listFeatures>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listFeatures>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFeaturesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a feature request. Requires an active session.
 * @summary Submit a new feature request
 */
export const getCreateFeatureUrl = () => {
  return `/api/features`;
};

export const createFeature = async (
  createFeatureBody: CreateFeatureBody,
  options?: RequestInit,
): Promise<FeatureRequestItem> => {
  return customFetch<FeatureRequestItem>(getCreateFeatureUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFeatureBody),
  });
};

export const getCreateFeatureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeature>>,
    TError,
    { data: BodyType<CreateFeatureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeature>>,
  TError,
  { data: BodyType<CreateFeatureBody> },
  TContext
> => {
  const mutationKey = ["createFeature"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeature>>,
    { data: BodyType<CreateFeatureBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createFeature(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeatureMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeature>>
>;
export type CreateFeatureMutationBody = BodyType<CreateFeatureBody>;
export type CreateFeatureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Submit a new feature request
 */
export const useCreateFeature = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeature>>,
    TError,
    { data: BodyType<CreateFeatureBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFeature>>,
  TError,
  { data: BodyType<CreateFeatureBody> },
  TContext
> => {
  return useMutation(getCreateFeatureMutationOptions(options));
};

/**
 * Adds or removes the caller's upvote. Requires an active session.
 * @summary Toggle upvote on a feature request
 */
export const getVoteFeatureUrl = (id: number) => {
  return `/api/features/${id}/vote`;
};

export const voteFeature = async (
  id: number,
  options?: RequestInit,
): Promise<FeatureVoteResponse> => {
  return customFetch<FeatureVoteResponse>(getVoteFeatureUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getVoteFeatureMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voteFeature>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof voteFeature>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["voteFeature"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof voteFeature>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return voteFeature(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VoteFeatureMutationResult = NonNullable<
  Awaited<ReturnType<typeof voteFeature>>
>;

export type VoteFeatureMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Toggle upvote on a feature request
 */
export const useVoteFeature = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof voteFeature>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof voteFeature>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getVoteFeatureMutationOptions(options));
};

/**
 * Returns all comments for a feature request in chronological order.
 * @summary List comments on a feature request
 */
export const getListFeatureCommentsUrl = (id: number) => {
  return `/api/features/${id}/comments`;
};

export const listFeatureComments = async (
  id: number,
  options?: RequestInit,
): Promise<FeatureCommentItem[]> => {
  return customFetch<FeatureCommentItem[]>(getListFeatureCommentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListFeatureCommentsQueryKey = (id: number) => {
  return [`/api/features/${id}/comments`] as const;
};

export const getListFeatureCommentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFeatureComments>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFeatureComments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFeatureCommentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFeatureComments>>
  > = ({ signal }) => listFeatureComments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFeatureComments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFeatureCommentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFeatureComments>>
>;
export type ListFeatureCommentsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List comments on a feature request
 */

export function useListFeatureComments<
  TData = Awaited<ReturnType<typeof listFeatureComments>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFeatureComments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFeatureCommentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Posts a comment. Requires an active session.
 * @summary Add a comment to a feature request
 */
export const getCreateFeatureCommentUrl = (id: number) => {
  return `/api/features/${id}/comments`;
};

export const createFeatureComment = async (
  id: number,
  createFeatureCommentBody: CreateFeatureCommentBody,
  options?: RequestInit,
): Promise<FeatureCommentItem> => {
  return customFetch<FeatureCommentItem>(getCreateFeatureCommentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createFeatureCommentBody),
  });
};

export const getCreateFeatureCommentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeatureComment>>,
    TError,
    { id: number; data: BodyType<CreateFeatureCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFeatureComment>>,
  TError,
  { id: number; data: BodyType<CreateFeatureCommentBody> },
  TContext
> => {
  const mutationKey = ["createFeatureComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFeatureComment>>,
    { id: number; data: BodyType<CreateFeatureCommentBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createFeatureComment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFeatureCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFeatureComment>>
>;
export type CreateFeatureCommentMutationBody =
  BodyType<CreateFeatureCommentBody>;
export type CreateFeatureCommentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Add a comment to a feature request
 */
export const useCreateFeatureComment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFeatureComment>>,
    TError,
    { id: number; data: BodyType<CreateFeatureCommentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFeatureComment>>,
  TError,
  { id: number; data: BodyType<CreateFeatureCommentBody> },
  TContext
> => {
  return useMutation(getCreateFeatureCommentMutationOptions(options));
};

/**
 * Deletes a comment. Only the comment author or an admin may delete.
 * @summary Delete a comment
 */
export const getDeleteFeatureCommentUrl = (id: number, commentId: number) => {
  return `/api/features/${id}/comments/${commentId}`;
};

export const deleteFeatureComment = async (
  id: number,
  commentId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteFeatureCommentUrl(id, commentId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteFeatureCommentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFeatureComment>>,
    TError,
    { id: number; commentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFeatureComment>>,
  TError,
  { id: number; commentId: number },
  TContext
> => {
  const mutationKey = ["deleteFeatureComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFeatureComment>>,
    { id: number; commentId: number }
  > = (props) => {
    const { id, commentId } = props ?? {};

    return deleteFeatureComment(id, commentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFeatureCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFeatureComment>>
>;

export type DeleteFeatureCommentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a comment
 */
export const useDeleteFeatureComment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFeatureComment>>,
    TError,
    { id: number; commentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFeatureComment>>,
  TError,
  { id: number; commentId: number },
  TContext
> => {
  return useMutation(getDeleteFeatureCommentMutationOptions(options));
};

/**
 * Flags a comment for admin review. Requires an active session.
 * @summary Report a comment
 */
export const getReportFeatureCommentUrl = (id: number, commentId: number) => {
  return `/api/features/${id}/comments/${commentId}/report`;
};

export const reportFeatureComment = async (
  id: number,
  commentId: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getReportFeatureCommentUrl(id, commentId), {
    ...options,
    method: "POST",
  });
};

export const getReportFeatureCommentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportFeatureComment>>,
    TError,
    { id: number; commentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportFeatureComment>>,
  TError,
  { id: number; commentId: number },
  TContext
> => {
  const mutationKey = ["reportFeatureComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportFeatureComment>>,
    { id: number; commentId: number }
  > = (props) => {
    const { id, commentId } = props ?? {};

    return reportFeatureComment(id, commentId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportFeatureCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportFeatureComment>>
>;

export type ReportFeatureCommentMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Report a comment
 */
export const useReportFeatureComment = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportFeatureComment>>,
    TError,
    { id: number; commentId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportFeatureComment>>,
  TError,
  { id: number; commentId: number },
  TContext
> => {
  return useMutation(getReportFeatureCommentMutationOptions(options));
};

/**
 * Sets the status and optional reason. Requires x-admin-token header.
 * @summary Update feature request status (admin only)
 */
export const getUpdateFeatureStatusUrl = (id: number) => {
  return `/api/features/${id}/status`;
};

export const updateFeatureStatus = async (
  id: number,
  updateFeatureStatusBody: UpdateFeatureStatusBody,
  options?: RequestInit,
): Promise<FeatureRequestItem> => {
  return customFetch<FeatureRequestItem>(getUpdateFeatureStatusUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateFeatureStatusBody),
  });
};

export const getUpdateFeatureStatusMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeatureStatus>>,
    TError,
    { id: number; data: BodyType<UpdateFeatureStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFeatureStatus>>,
  TError,
  { id: number; data: BodyType<UpdateFeatureStatusBody> },
  TContext
> => {
  const mutationKey = ["updateFeatureStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFeatureStatus>>,
    { id: number; data: BodyType<UpdateFeatureStatusBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFeatureStatus(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFeatureStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFeatureStatus>>
>;
export type UpdateFeatureStatusMutationBody = BodyType<UpdateFeatureStatusBody>;
export type UpdateFeatureStatusMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update feature request status (admin only)
 */
export const useUpdateFeatureStatus = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFeatureStatus>>,
    TError,
    { id: number; data: BodyType<UpdateFeatureStatusBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFeatureStatus>>,
  TError,
  { id: number; data: BodyType<UpdateFeatureStatusBody> },
  TContext
> => {
  return useMutation(getUpdateFeatureStatusMutationOptions(options));
};

/**
 * Returns a deduplicated, sorted list of all tags currently in use across community event posts. Public, no auth required.
 * @summary List all active tags
 */
export const getListActiveTagsUrl = () => {
  return `/api/tags/active`;
};

export const listActiveTags = async (
  options?: RequestInit,
): Promise<string[]> => {
  return customFetch<string[]>(getListActiveTagsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListActiveTagsQueryKey = () => {
  return [`/api/tags/active`] as const;
};

export const getListActiveTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveTags>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listActiveTags>>> = ({
    signal,
  }) => listActiveTags({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveTags>>
>;
export type ListActiveTagsQueryError = ErrorType<unknown>;

/**
 * @summary List all active tags
 */

export function useListActiveTags<
  TData = Awaited<ReturnType<typeof listActiveTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveTags>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns a deduplicated, sorted list of discipline and title values drawn from all alumni profiles. Used to populate the Discipline(s) combobox on job posting forms. Public, no auth required.
 * @summary List member taxonomy tags for Discipline(s)
 */
export const getGetJobTagsUrl = () => {
  return `/api/jobs/tags`;
};

export const getJobTags = async (options?: RequestInit): Promise<JobTag[]> => {
  return customFetch<JobTag[]>(getGetJobTagsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetJobTagsQueryKey = () => {
  return [`/api/jobs/tags`] as const;
};

export const getGetJobTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getJobTags>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobTags>>> = ({
    signal,
  }) => getJobTags({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobTags>>
>;
export type GetJobTagsQueryError = ErrorType<unknown>;

/**
 * @summary List member taxonomy tags for Discipline(s)
 */

export function useGetJobTags<
  TData = Awaited<ReturnType<typeof getJobTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getJobTags>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns deduplicated, sorted lists of industryFocus values and locations entries across all active job posts, split by category. Public, no auth required.
 * @summary List all active job-board tags
 */
export const getListActiveJobTagsUrl = () => {
  return `/api/jobs/tags/active`;
};

export const listActiveJobTags = async (
  options?: RequestInit,
): Promise<ActiveJobTags> => {
  return customFetch<ActiveJobTags>(getListActiveJobTagsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListActiveJobTagsQueryKey = () => {
  return [`/api/jobs/tags/active`] as const;
};

export const getListActiveJobTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof listActiveJobTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveJobTags>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListActiveJobTagsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listActiveJobTags>>
  > = ({ signal }) => listActiveJobTags({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listActiveJobTags>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListActiveJobTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listActiveJobTags>>
>;
export type ListActiveJobTagsQueryError = ErrorType<unknown>;

/**
 * @summary List all active job-board tags
 */

export function useListActiveJobTags<
  TData = Awaited<ReturnType<typeof listActiveJobTags>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listActiveJobTags>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListActiveJobTagsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the list of tag strings the current user has subscribed to for the given subscription type. Defaults to `community` for backward compatibility. Requires authentication.
 * @summary Get the authenticated user's tag subscriptions
 */
export const getGetMyTagSubscriptionsUrl = (
  params?: GetMyTagSubscriptionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/users/me/tag-subscriptions?${stringifiedParams}`
    : `/api/users/me/tag-subscriptions`;
};

export const getMyTagSubscriptions = async (
  params?: GetMyTagSubscriptionsParams,
  options?: RequestInit,
): Promise<string[]> => {
  return customFetch<string[]>(getGetMyTagSubscriptionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMyTagSubscriptionsQueryKey = (
  params?: GetMyTagSubscriptionsParams,
) => {
  return [
    `/api/users/me/tag-subscriptions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMyTagSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyTagSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetMyTagSubscriptionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyTagSubscriptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyTagSubscriptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyTagSubscriptions>>
  > = ({ signal }) =>
    getMyTagSubscriptions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyTagSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyTagSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyTagSubscriptions>>
>;
export type GetMyTagSubscriptionsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the authenticated user's tag subscriptions
 */

export function useGetMyTagSubscriptions<
  TData = Awaited<ReturnType<typeof getMyTagSubscriptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetMyTagSubscriptionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMyTagSubscriptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyTagSubscriptionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Overwrites the user's tag subscriptions for the given `subscriptionType` atomically. Only tags present in the matching active-tag list are accepted; unknown tags are filtered out. The other subscription type is untouched. Requires authentication.
 * @summary Update the authenticated user's tag subscriptions
 */
export const getUpdateMyTagSubscriptionsUrl = () => {
  return `/api/users/me/tag-subscriptions`;
};

export const updateMyTagSubscriptions = async (
  updateTagSubscriptionsBody: UpdateTagSubscriptionsBody,
  options?: RequestInit,
): Promise<string[]> => {
  return customFetch<string[]>(getUpdateMyTagSubscriptionsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTagSubscriptionsBody),
  });
};

export const getUpdateMyTagSubscriptionsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyTagSubscriptions>>,
    TError,
    { data: BodyType<UpdateTagSubscriptionsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMyTagSubscriptions>>,
  TError,
  { data: BodyType<UpdateTagSubscriptionsBody> },
  TContext
> => {
  const mutationKey = ["updateMyTagSubscriptions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMyTagSubscriptions>>,
    { data: BodyType<UpdateTagSubscriptionsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateMyTagSubscriptions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMyTagSubscriptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMyTagSubscriptions>>
>;
export type UpdateMyTagSubscriptionsMutationBody =
  BodyType<UpdateTagSubscriptionsBody>;
export type UpdateMyTagSubscriptionsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the authenticated user's tag subscriptions
 */
export const useUpdateMyTagSubscriptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMyTagSubscriptions>>,
    TError,
    { data: BodyType<UpdateTagSubscriptionsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMyTagSubscriptions>>,
  TError,
  { data: BodyType<UpdateTagSubscriptionsBody> },
  TContext
> => {
  return useMutation(getUpdateMyTagSubscriptionsMutationOptions(options));
};

/**
 * Writes the current timestamp to `featuresLastViewedAt` on the user row. Auth-gated — 401 for unauthenticated callers. Unauthenticated visitors receive 204 with no DB write.
 * @summary Record that the authenticated user has viewed the Features tab
 */
export const getMarkFeaturesViewedUrl = () => {
  return `/api/users/me/features-viewed`;
};

export const markFeaturesViewed = async (
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getMarkFeaturesViewedUrl(), {
    ...options,
    method: "POST",
  });
};

export const getMarkFeaturesViewedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markFeaturesViewed>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markFeaturesViewed>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["markFeaturesViewed"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markFeaturesViewed>>,
    void
  > = () => {
    return markFeaturesViewed(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkFeaturesViewedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markFeaturesViewed>>
>;

export type MarkFeaturesViewedMutationError = ErrorType<unknown>;

/**
 * @summary Record that the authenticated user has viewed the Features tab
 */
export const useMarkFeaturesViewed = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markFeaturesViewed>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markFeaturesViewed>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getMarkFeaturesViewedMutationOptions(options));
};

/**
 * Updates the user's saved-profile alert opt-out preference. Requires authentication.
 * @summary Update the authenticated user's alert preferences
 */
export const getPatchMyAlertPreferencesUrl = () => {
  return `/api/users/me/alerts`;
};

export const patchMyAlertPreferences = async (
  alumniAlertPreferencesBody: AlumniAlertPreferencesBody,
  options?: RequestInit,
): Promise<AlumniAlertPreferencesResponse> => {
  return customFetch<AlumniAlertPreferencesResponse>(
    getPatchMyAlertPreferencesUrl(),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(alumniAlertPreferencesBody),
    },
  );
};

export const getPatchMyAlertPreferencesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMyAlertPreferences>>,
    TError,
    { data: BodyType<AlumniAlertPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchMyAlertPreferences>>,
  TError,
  { data: BodyType<AlumniAlertPreferencesBody> },
  TContext
> => {
  const mutationKey = ["patchMyAlertPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchMyAlertPreferences>>,
    { data: BodyType<AlumniAlertPreferencesBody> }
  > = (props) => {
    const { data } = props ?? {};

    return patchMyAlertPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchMyAlertPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchMyAlertPreferences>>
>;
export type PatchMyAlertPreferencesMutationBody =
  BodyType<AlumniAlertPreferencesBody>;
export type PatchMyAlertPreferencesMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update the authenticated user's alert preferences
 */
export const usePatchMyAlertPreferences = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchMyAlertPreferences>>,
    TError,
    { data: BodyType<AlumniAlertPreferencesBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchMyAlertPreferences>>,
  TError,
  { data: BodyType<AlumniAlertPreferencesBody> },
  TContext
> => {
  return useMutation(getPatchMyAlertPreferencesMutationOptions(options));
};

/**
 * Returns all community/event posts. Supports filtering by type and sorting by trending or new.
 * @summary List community events posts
 */
export const getListCommunityEventsUrl = (
  params?: ListCommunityEventsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/communities-events?${stringifiedParams}`
    : `/api/communities-events`;
};

export const listCommunityEvents = async (
  params?: ListCommunityEventsParams,
  options?: RequestInit,
): Promise<CommunityEventPost[]> => {
  return customFetch<CommunityEventPost[]>(getListCommunityEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCommunityEventsQueryKey = (
  params?: ListCommunityEventsParams,
) => {
  return [`/api/communities-events`, ...(params ? [params] : [])] as const;
};

export const getListCommunityEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCommunityEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCommunityEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCommunityEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCommunityEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCommunityEvents>>
  > = ({ signal }) =>
    listCommunityEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCommunityEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCommunityEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCommunityEvents>>
>;
export type ListCommunityEventsQueryError = ErrorType<unknown>;

/**
 * @summary List community events posts
 */

export function useListCommunityEvents<
  TData = Awaited<ReturnType<typeof listCommunityEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCommunityEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCommunityEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCommunityEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a new community/event post. Requires an active session. At least one of link or contactInfo must be provided.
 * @summary Create a community event post
 */
export const getCreateCommunityEventUrl = () => {
  return `/api/communities-events`;
};

export const createCommunityEvent = async (
  createCommunityEventBody: CreateCommunityEventBody,
  options?: RequestInit,
): Promise<CommunityEventPost> => {
  return customFetch<CommunityEventPost>(getCreateCommunityEventUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createCommunityEventBody),
  });
};

export const getCreateCommunityEventMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunityEvent>>,
    TError,
    { data: BodyType<CreateCommunityEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCommunityEvent>>,
  TError,
  { data: BodyType<CreateCommunityEventBody> },
  TContext
> => {
  const mutationKey = ["createCommunityEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCommunityEvent>>,
    { data: BodyType<CreateCommunityEventBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCommunityEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCommunityEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCommunityEvent>>
>;
export type CreateCommunityEventMutationBody =
  BodyType<CreateCommunityEventBody>;
export type CreateCommunityEventMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a community event post
 */
export const useCreateCommunityEvent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCommunityEvent>>,
    TError,
    { data: BodyType<CreateCommunityEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCommunityEvent>>,
  TError,
  { data: BodyType<CreateCommunityEventBody> },
  TContext
> => {
  return useMutation(getCreateCommunityEventMutationOptions(options));
};

/**
 * @summary Get a single community event post
 */
export const getGetCommunityEventUrl = (id: number) => {
  return `/api/communities-events/${id}`;
};

export const getCommunityEvent = async (
  id: number,
  options?: RequestInit,
): Promise<CommunityEventPost> => {
  return customFetch<CommunityEventPost>(getGetCommunityEventUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCommunityEventQueryKey = (id: number) => {
  return [`/api/communities-events/${id}`] as const;
};

export const getGetCommunityEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunityEvent>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommunityEvent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommunityEventQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCommunityEvent>>
  > = ({ signal }) => getCommunityEvent(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunityEvent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCommunityEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunityEvent>>
>;
export type GetCommunityEventQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a single community event post
 */

export function useGetCommunityEvent<
  TData = Awaited<ReturnType<typeof getCommunityEvent>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCommunityEvent>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCommunityEventQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates the post. Only the author can update. At least one of link or contactInfo must be provided.
 * @summary Update a community event post
 */
export const getUpdateCommunityEventUrl = (id: number) => {
  return `/api/communities-events/${id}`;
};

export const updateCommunityEvent = async (
  id: number,
  updateCommunityEventBody: UpdateCommunityEventBody,
  options?: RequestInit,
): Promise<CommunityEventPost> => {
  return customFetch<CommunityEventPost>(getUpdateCommunityEventUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCommunityEventBody),
  });
};

export const getUpdateCommunityEventMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunityEvent>>,
    TError,
    { id: number; data: BodyType<UpdateCommunityEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCommunityEvent>>,
  TError,
  { id: number; data: BodyType<UpdateCommunityEventBody> },
  TContext
> => {
  const mutationKey = ["updateCommunityEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCommunityEvent>>,
    { id: number; data: BodyType<UpdateCommunityEventBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCommunityEvent(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCommunityEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCommunityEvent>>
>;
export type UpdateCommunityEventMutationBody =
  BodyType<UpdateCommunityEventBody>;
export type UpdateCommunityEventMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update a community event post
 */
export const useUpdateCommunityEvent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCommunityEvent>>,
    TError,
    { id: number; data: BodyType<UpdateCommunityEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCommunityEvent>>,
  TError,
  { id: number; data: BodyType<UpdateCommunityEventBody> },
  TContext
> => {
  return useMutation(getUpdateCommunityEventMutationOptions(options));
};

/**
 * Hard-deletes the post. Only the author can delete.
 * @summary Delete a community event post
 */
export const getDeleteCommunityEventUrl = (id: number) => {
  return `/api/communities-events/${id}`;
};

export const deleteCommunityEvent = async (
  id: number,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteCommunityEventUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCommunityEventMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunityEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCommunityEvent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCommunityEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCommunityEvent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCommunityEvent(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCommunityEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCommunityEvent>>
>;

export type DeleteCommunityEventMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a community event post
 */
export const useDeleteCommunityEvent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCommunityEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCommunityEvent>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteCommunityEventMutationOptions(options));
};

/**
 * Moves the post to the top of the feed by updating bumpedAt. Only the author can bump. 7-day cooldown enforced server-side.
 * @summary Bump a community event post
 */
export const getBumpCommunityEventUrl = (id: number) => {
  return `/api/communities-events/${id}/bump`;
};

export const bumpCommunityEvent = async (
  id: number,
  options?: RequestInit,
): Promise<CommunityEventPost> => {
  return customFetch<CommunityEventPost>(getBumpCommunityEventUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getBumpCommunityEventMutationOptions = <
  TError = ErrorType<ErrorResponse | BumpCooldownResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bumpCommunityEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bumpCommunityEvent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["bumpCommunityEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bumpCommunityEvent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return bumpCommunityEvent(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BumpCommunityEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof bumpCommunityEvent>>
>;

export type BumpCommunityEventMutationError = ErrorType<
  ErrorResponse | BumpCooldownResponse
>;

/**
 * @summary Bump a community event post
 */
export const useBumpCommunityEvent = <
  TError = ErrorType<ErrorResponse | BumpCooldownResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bumpCommunityEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bumpCommunityEvent>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getBumpCommunityEventMutationOptions(options));
};

/**
 * Toggles the authenticated user's upvote on the post. Insert if not voted, delete if already voted. Returns the new count and vote state. Requires an active session.
 * @summary Toggle upvote on a community post
 */
export const getUpvoteCommunityEventUrl = (id: number) => {
  return `/api/communities-events/${id}/upvote`;
};

export const upvoteCommunityEvent = async (
  id: number,
  options?: RequestInit,
): Promise<UpvoteCommunityEventResponse> => {
  return customFetch<UpvoteCommunityEventResponse>(
    getUpvoteCommunityEventUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getUpvoteCommunityEventMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upvoteCommunityEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upvoteCommunityEvent>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["upvoteCommunityEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upvoteCommunityEvent>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return upvoteCommunityEvent(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpvoteCommunityEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof upvoteCommunityEvent>>
>;

export type UpvoteCommunityEventMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Toggle upvote on a community post
 */
export const useUpvoteCommunityEvent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upvoteCommunityEvent>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upvoteCommunityEvent>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getUpvoteCommunityEventMutationOptions(options));
};

/**
 * Increments reportCount and logs a report server-side. Requires an active session.
 * @summary Report a community event post
 */
export const getReportCommunityEventUrl = (id: number) => {
  return `/api/communities-events/${id}/report`;
};

export const reportCommunityEvent = async (
  id: number,
  reportCommunityEventBody?: ReportCommunityEventBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getReportCommunityEventUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reportCommunityEventBody),
  });
};

export const getReportCommunityEventMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportCommunityEvent>>,
    TError,
    { id: number; data: BodyType<ReportCommunityEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reportCommunityEvent>>,
  TError,
  { id: number; data: BodyType<ReportCommunityEventBody> },
  TContext
> => {
  const mutationKey = ["reportCommunityEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportCommunityEvent>>,
    { id: number; data: BodyType<ReportCommunityEventBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reportCommunityEvent(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReportCommunityEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportCommunityEvent>>
>;
export type ReportCommunityEventMutationBody =
  BodyType<ReportCommunityEventBody>;
export type ReportCommunityEventMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Report a community event post
 */
export const useReportCommunityEvent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reportCommunityEvent>>,
    TError,
    { id: number; data: BodyType<ReportCommunityEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reportCommunityEvent>>,
  TError,
  { id: number; data: BodyType<ReportCommunityEventBody> },
  TContext
> => {
  return useMutation(getReportCommunityEventMutationOptions(options));
};

/**
 * Converts the supplied markdown body to inline-styled, email-safe HTML using the single server-side converter (the only source of truth for the compose preview). Requires admin token or admin role session.
 * @summary Render platform-update markdown to email HTML
 */
export const getPreviewPlatformUpdateUrl = () => {
  return `/api/admin/platform-updates/preview`;
};

export const previewPlatformUpdate = async (
  previewPlatformUpdateBody: PreviewPlatformUpdateBody,
  options?: RequestInit,
): Promise<PlatformUpdatePreviewResponse> => {
  return customFetch<PlatformUpdatePreviewResponse>(
    getPreviewPlatformUpdateUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(previewPlatformUpdateBody),
    },
  );
};

export const getPreviewPlatformUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPlatformUpdate>>,
    TError,
    { data: BodyType<PreviewPlatformUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewPlatformUpdate>>,
  TError,
  { data: BodyType<PreviewPlatformUpdateBody> },
  TContext
> => {
  const mutationKey = ["previewPlatformUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewPlatformUpdate>>,
    { data: BodyType<PreviewPlatformUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return previewPlatformUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewPlatformUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewPlatformUpdate>>
>;
export type PreviewPlatformUpdateMutationBody =
  BodyType<PreviewPlatformUpdateBody>;
export type PreviewPlatformUpdateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Render platform-update markdown to email HTML
 */
export const usePreviewPlatformUpdate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPlatformUpdate>>,
    TError,
    { data: BodyType<PreviewPlatformUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewPlatformUpdate>>,
  TError,
  { data: BodyType<PreviewPlatformUpdateBody> },
  TContext
> => {
  return useMutation(getPreviewPlatformUpdateMutationOptions(options));
};

/**
 * Fans out one webhook per opted-in verified recipient (audience read from profiles.email). With dryRun=true returns only the recipient count and sends nothing. Sending requires confirm=true; otherwise returns 400. Requires admin token or admin role session.
 * @summary Send (or dry-run) a platform-update broadcast
 */
export const getSendPlatformUpdateUrl = () => {
  return `/api/admin/platform-updates/send`;
};

export const sendPlatformUpdate = async (
  sendPlatformUpdateBody: SendPlatformUpdateBody,
  options?: RequestInit,
): Promise<SendPlatformUpdateResponse> => {
  return customFetch<SendPlatformUpdateResponse>(getSendPlatformUpdateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendPlatformUpdateBody),
  });
};

export const getSendPlatformUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPlatformUpdate>>,
    TError,
    { data: BodyType<SendPlatformUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendPlatformUpdate>>,
  TError,
  { data: BodyType<SendPlatformUpdateBody> },
  TContext
> => {
  const mutationKey = ["sendPlatformUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendPlatformUpdate>>,
    { data: BodyType<SendPlatformUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return sendPlatformUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendPlatformUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendPlatformUpdate>>
>;
export type SendPlatformUpdateMutationBody = BodyType<SendPlatformUpdateBody>;
export type SendPlatformUpdateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send (or dry-run) a platform-update broadcast
 */
export const useSendPlatformUpdate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendPlatformUpdate>>,
    TError,
    { data: BodyType<SendPlatformUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendPlatformUpdate>>,
  TError,
  { data: BodyType<SendPlatformUpdateBody> },
  TContext
> => {
  return useMutation(getSendPlatformUpdateMutationOptions(options));
};

/**
 * Fires the real send pipeline to a single recipient — the admin's own profiles.email (with a users.email / ADMIN_TEST_EMAIL fallback). Does not write to the broadcast log. Requires admin token or admin role session.
 * @summary Send a platform-update test to the admin's own email
 */
export const getSendTestPlatformUpdateUrl = () => {
  return `/api/admin/platform-updates/send-test`;
};

export const sendTestPlatformUpdate = async (
  sendTestPlatformUpdateBody: SendTestPlatformUpdateBody,
  options?: RequestInit,
): Promise<SendTestPlatformUpdateResponse> => {
  return customFetch<SendTestPlatformUpdateResponse>(
    getSendTestPlatformUpdateUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(sendTestPlatformUpdateBody),
    },
  );
};

export const getSendTestPlatformUpdateMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestPlatformUpdate>>,
    TError,
    { data: BodyType<SendTestPlatformUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTestPlatformUpdate>>,
  TError,
  { data: BodyType<SendTestPlatformUpdateBody> },
  TContext
> => {
  const mutationKey = ["sendTestPlatformUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTestPlatformUpdate>>,
    { data: BodyType<SendTestPlatformUpdateBody> }
  > = (props) => {
    const { data } = props ?? {};

    return sendTestPlatformUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTestPlatformUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTestPlatformUpdate>>
>;
export type SendTestPlatformUpdateMutationBody =
  BodyType<SendTestPlatformUpdateBody>;
export type SendTestPlatformUpdateMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send a platform-update test to the admin's own email
 */
export const useSendTestPlatformUpdate = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestPlatformUpdate>>,
    TError,
    { data: BodyType<SendTestPlatformUpdateBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTestPlatformUpdate>>,
  TError,
  { data: BodyType<SendTestPlatformUpdateBody> },
  TContext
> => {
  return useMutation(getSendTestPlatformUpdateMutationOptions(options));
};

/**
 * Returns rows from platform_broadcast_log ordered by sentAt descending (timestamp, subject, recipient count). Requires admin token or admin role session.
 * @summary List past platform-update broadcasts
 */
export const getGetPlatformUpdateHistoryUrl = () => {
  return `/api/admin/platform-updates/history`;
};

export const getPlatformUpdateHistory = async (
  options?: RequestInit,
): Promise<PlatformBroadcastHistoryResponse> => {
  return customFetch<PlatformBroadcastHistoryResponse>(
    getGetPlatformUpdateHistoryUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlatformUpdateHistoryQueryKey = () => {
  return [`/api/admin/platform-updates/history`] as const;
};

export const getGetPlatformUpdateHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformUpdateHistory>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformUpdateHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformUpdateHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformUpdateHistory>>
  > = ({ signal }) => getPlatformUpdateHistory({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformUpdateHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformUpdateHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformUpdateHistory>>
>;
export type GetPlatformUpdateHistoryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List past platform-update broadcasts
 */

export function useGetPlatformUpdateHistory<
  TData = Awaited<ReturnType<typeof getPlatformUpdateHistory>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformUpdateHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformUpdateHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Verifies the token and renders a minimal HTML page with a single Unsubscribe button that POSTs to the same URL. Performs NO state change (prevents email scanners from silently unsubscribing via link prefetch).
 * @summary Render the platform-updates unsubscribe confirmation page
 */
export const getGetPlatformUnsubscribePageUrl = (token: string) => {
  return `/api/unsubscribe/platform/${token}`;
};

export const getPlatformUnsubscribePage = async (
  token: string,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getGetPlatformUnsubscribePageUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetPlatformUnsubscribePageQueryKey = (token: string) => {
  return [`/api/unsubscribe/platform/${token}`] as const;
};

export const getGetPlatformUnsubscribePageQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformUnsubscribePage>>,
  TError = ErrorType<string>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformUnsubscribePage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPlatformUnsubscribePageQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformUnsubscribePage>>
  > = ({ signal }) =>
    getPlatformUnsubscribePage(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformUnsubscribePage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformUnsubscribePageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformUnsubscribePage>>
>;
export type GetPlatformUnsubscribePageQueryError = ErrorType<string>;

/**
 * @summary Render the platform-updates unsubscribe confirmation page
 */

export function useGetPlatformUnsubscribePage<
  TData = Awaited<ReturnType<typeof getPlatformUnsubscribePage>>,
  TError = ErrorType<string>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPlatformUnsubscribePage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformUnsubscribePageQueryOptions(
    token,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * The only handler that changes state. Serves both the page button (browser POST → renders a confirmation page) and the RFC 8058 one-click header (form body List-Unsubscribe=One-Click → returns HTTP 200 with no body). Idempotent: repeat hits succeed without a duplicate consent-log row.
 * @summary Perform the platform-updates opt-out
 */
export const getPostPlatformUnsubscribeUrl = (token: string) => {
  return `/api/unsubscribe/platform/${token}`;
};

export const postPlatformUnsubscribe = async (
  token: string,
  postPlatformUnsubscribeBody?:
    | PostPlatformUnsubscribeBodyOne
    | PostPlatformUnsubscribeBodyTwo,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getPostPlatformUnsubscribeUrl(token), {
    ...options,
    method: "POST",
    body: JSON.stringify(postPlatformUnsubscribeBody),
  });
};

export const getPostPlatformUnsubscribeMutationOptions = <
  TError = ErrorType<string>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPlatformUnsubscribe>>,
    TError,
    {
      token: string;
      data: BodyType<
        PostPlatformUnsubscribeBodyOne | PostPlatformUnsubscribeBodyTwo
      >;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPlatformUnsubscribe>>,
  TError,
  {
    token: string;
    data: BodyType<
      PostPlatformUnsubscribeBodyOne | PostPlatformUnsubscribeBodyTwo
    >;
  },
  TContext
> => {
  const mutationKey = ["postPlatformUnsubscribe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPlatformUnsubscribe>>,
    {
      token: string;
      data: BodyType<
        PostPlatformUnsubscribeBodyOne | PostPlatformUnsubscribeBodyTwo
      >;
    }
  > = (props) => {
    const { token, data } = props ?? {};

    return postPlatformUnsubscribe(token, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPlatformUnsubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPlatformUnsubscribe>>
>;
export type PostPlatformUnsubscribeMutationBody = BodyType<
  PostPlatformUnsubscribeBodyOne | PostPlatformUnsubscribeBodyTwo
>;
export type PostPlatformUnsubscribeMutationError = ErrorType<string>;

/**
 * @summary Perform the platform-updates opt-out
 */
export const usePostPlatformUnsubscribe = <
  TError = ErrorType<string>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPlatformUnsubscribe>>,
    TError,
    {
      token: string;
      data: BodyType<
        PostPlatformUnsubscribeBodyOne | PostPlatformUnsubscribeBodyTwo
      >;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postPlatformUnsubscribe>>,
  TError,
  {
    token: string;
    data: BodyType<
      PostPlatformUnsubscribeBodyOne | PostPlatformUnsubscribeBodyTwo
    >;
  },
  TContext
> => {
  return useMutation(getPostPlatformUnsubscribeMutationOptions(options));
};
